<!--详情页面-->
<template>
  <div>
  <el-dialog
    :title="pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle" @close="orderClose"
    :visible.sync="dialogSeeVisible"  center :close-on-click-modal="false" :append-to-body="appendToBody" :modal="noModal !== true" :custom-class="customClass || 'medium-dialog'">
    <div ref="print1" style="width: 100%;margin: 0 auto;">
    <!-- 嵌入模式的按钮栏（顶部） -->
    <div v-if="noModal&&!isprint" style="border-bottom:1px solid #dcdfe6;padding:8px 15px;background:#fff;margin-bottom:8px;text-align: right">
      <el-button type="primary" @click="printOutStock" v-if="printoutstock&&showOnlyPrintOutstock" size="mini">缺货单打印</el-button>
      <template v-if="!showOnlyPrintOutstock">
      <el-button type="primary" @click="printPre(1)" v-if="(roletype!='order'&&status!=200)||isFrame||order200print" size="mini">发货单打印</el-button>
      <el-button type="primary" @click="printPre(2)" v-if="((roletype!='order'&&status!=200)||isFrame||order200print)&&!hasBaiBao&&printDisplay" size="mini">发货单打印(无价格)</el-button>
      </template>
    </div>
      <!--库位号（页面左上角）-->
      <span v-if="binallocation&&storenum>0" style="float:left;">
        <b style="border:2px solid #333;border-radius:50%;padding:0 6px;font-size:20px;font-weight:bold;">{{storenum}}</b>
      </span>
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">
        {{isPrintOutStock?(pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle).replace('销售订单','缺货单'):printBaiBao?(pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle).replace('销售订单','取货单'):(pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle)}}
      </p>
      <!--<div v-if="controlData.isjiaji==1" style="color:red;margin-left: 20px;font-weight:bold;float:left ">-->
        <!--<span>加急！！</span>&nbsp;（{{controlData.wantarrivaltime}}）-->
      <!--</div>-->
      <template v-if="isprint"><template v-if="!isPrintOutStock">
        <div v-if="imgLogURL" style="margin-left: 20px;float:left "><img :src="imgLogURL" style="max-height:45px;width:auto" v-if="imgLogURL&&imgLogURL.indexOf('http')>-1">
      <div v-else v-html="imgLogURL" style="font-weight: bolder;font-size:8pt;line-height:10pt"></div></div>
        <div v-if="ticket&&ticket.indexOf('$')>-1" style="margin-left: 10px; float: left;">
          <span :key="tag" v-for="tag in ticket?ticket.split('$')[1].split(';'):[]" class="el-tag el-tag--mini el-tag--light" style="margin-left: 5px;" v-if="tag">{{tag}}</span>
        </div></template>
      </template>
      <template v-else>
        <div v-if="linecredit&&linecredit!=0" :style="{color:linecredit<0?'red':'blue'}" style="margin-left: 20px;font-weight:bold;float:left ">
           <span>信用额度：</span>{{linecredit}}
        </div>
        <div v-if="ticket" style="margin-left: 10px; float: left;">
          <span :key="tag" v-for="tag in ticket?ticket.replace('$',';').split(';'):['加标签']" class="el-tag el-tag--mini el-tag--light" style="margin-left: 5px;" v-if="tag">{{tag}}</span>
        </div>
      </template>
      <div v-if="controlData.isfile&&controlData.isfile==9&&controlData.filepalce" style="margin-left: 10px;float:left ">
        <el-tag  :disable-transitions="false" size="mini" style="margin-left: 5px">直发：<b>{{controlData.isfile==9&&controlData.filepalce?JSON.parse(controlData.filepalce).c:''}}</b></el-tag>
      </div>
      <div style="width: 640px;margin: 0 auto;text-align: right;"><img :src="imgpath"/></div>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="print-table">
        <tr class="noborder" style="height:26px">
          <td align="right" style="width: 60px">订单号：</td>
          <td style="width: 200px;max-width: 200px">{{controlData.erpserial}}</td>
          <td align="right" style="width: 60px">时&nbsp;&nbsp;间：</td>
          <td>{{controlData.htqd||controlData.adddate}}</td>
          <td align="right" style="width: 60px" >仓&nbsp;&nbsp;库：</td>
          <td style="width: 130px" v-if="(isprint||status<350)">{{controlData.cangkuname}}{{controlData.warehouse}}</td>
          <td v-else style="width: 180px">
             {{controlData.cangkuname}}<!--&&btn!='填写发货单'-->
            <span style="font-size: larger"><b>{{controlData.warehousename}}</b></span>
            {{controlData.warehouse}}
            <span
              class="no-print" style="color: blue;cursor:pointer;margin-left: 10px"
              @click="updatecangku(controlData)"
              v-if="(status==350||status==660)&&controlData.isreturnorder!=-1&&isShowAdressAndCangkuUpdate">修改</span>
          </td>
        </tr>
        <tr class="noborder" style="height:26px">
          <td align="right">门&nbsp;&nbsp;店：</td>
          <td style="width: 200px;max-width: 200px"><span style="font-size: larger"><b>{{controlData.customername}}</b></span> {{controlData.customerserial}} {{controlData.shortname||''}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.deliveryaddress}}<span
            class="no-print" style="color: blue;cursor:pointer;margin-left: 10px"
            v-if="controlData.status<500&&controlData.isreturnorder!=-1&&isShowAdressAndCangkuUpdate"
            @click="updateaddress">修改</span></td>
          <td align="right">联系人：</td>
          <td><span>{{(controlData.linkman||"")+" " +((controlData.linkmantel&&controlData.linkmantel!='null')?controlData.linkmantel:'')}}</span></td>
        </tr>
        <tr class="noborder" style="height:26px" v-if="!isPrintOutStock">
          <td align="right">运&nbsp;&nbsp;费：</td>
          <td>￥{{controlData.expressfee}} <span v-if="!isprint||controlData.status==350">{{controlData.deliverymode}}</span>
            <span v-if="isprint&&controlData.status==500&&controlData.machinecstagreementDO&&controlData.machinecstagreementDO.unitguid">{{form.logisticsco+' '+form.logisticsnum}}</span>
            <span class="no-print" style="color: blue;cursor:pointer;margin-left: 10px" v-if="controlData.status<500&&controlData.paymethod&&controlData.paymethod.indexOf('按合同结算')>-1&&controlData.isreturnorder!=-1&&isShowAdressAndCangkuUpdate"
            @click="showupdateExpressFee()">修改</span>
          </td>
          <template v-if="controlData.machinecstagreementDO&&controlData.machinecstagreementDO.unitguid">
          <td align="right" >加工单：</td>
          <td  style="font-weight:bold;cursor:pointer" @click="lookMachineOrder(controlData.machinecstagreementDO)">
            <span v-if="controlData.machinecstagreementDO">{{controlData.machinecstagreementDO.erpserial}} {{controlData.machinecstagreementDO.seedinfo}}</span>
            <span v-if="controlData.machinecstagreementDO&&(printDisplay)">、{{controlData.machinecstagreementDO.htje-controlData.machinecstagreementDO.discount|0}}元</span>
            <span class="no-print">（{{("("+controlData.machinecstagreementDO&&parseFloat(controlData.machinecstagreementDO.status+")")>300?'已加工':'待加工')}}）</span>
            <span style="width: 240px;"><img :src="jiagongimgpath"/></span>
          </td>
          </template>
          <template v-else>
            <template v-if="!isprint&&(controlData.status==350||controlData.status==200)&&controlData.paymethod&&controlData.isreturnorder!=-1&&isShowAdressAndCangkuUpdate">
              <!--&&controlData.paymethod.indexOf('按合同结算')>-1-->
              <td align="right no-print" >&nbsp;</td>
              <td class="no-print"><span style="color: blue;width: 240px;font-weight:bold;cursor:pointer"  @click="addMachineOrder()">补加工单</span></td>
            </template>
            <template v-else>
              <td>&nbsp;</td>
              <td>&nbsp;<span v-if="isprint&&controlData.status==500">{{form.logisticsco+' '+form.logisticsnum}}</span></td>
            </template>
          </template>
          <template v-if="buyinfo&&buyinfo.erpserial">
          <td align="right" class="no-print">采购单：</td>
          <td class="no-print">
            {{(buyinfo?buyinfo.erpserial:'')}}
          </td>
          </template>
          <template v-if="(status==500||status==400)&&isprint">
            <td align="right">发货时：</td>
            <td>{{formatTime(controlData.handleoverdate)}}</td>
          </template>
        </tr>
        <tr class="noborder no-print" v-show="status>=350&&status<650" style="height:26px">
          <td align="right">物&nbsp;&nbsp;流：</td>
          <td>
              <el-select v-if="!isprint" v-model="form.logisticsco" placeholder="请选择" style="width: 125px;" size="mini">
                <el-option
                  v-for="item in parameterData"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            <span v-if="isprint">{{form.logisticsco}}</span>
          </td>
          <td align="right">快递号：</td>
          <td v-if="!isprint">
            <el-input  v-model="form.logisticsnum" auto-complete="off" required="true" size="mini"
                      style="width: 135px;" placeholder="请填写快递单号"></el-input>
            <template v-if="form.logisticsnum">
              <el-button circle type="info" @click="OrderPrint(false)" :loading="loadingexpress" icon="el-icon-printer" title="打印-快递单" size="mini"></el-button>
              <el-button circle type="warning" @click="OrderPrint(true)" :loading="loadingexpress" icon="el-icon-printer" title="打印-快递单" size="mini"></el-button>
              <!--<el-button circle type="warning" @click="RouteService" icon="el-icon-truck" title="查询-物流" size="mini"></el-button>-->
              <el-button circle type="danger" @click="removeOrderService" :loading="loadingexpress" icon="el-icon-delete" title="撤销-快递单" size="mini"></el-button>
            </template>
            <el-button v-else circle type="success" @click="createOrderService" :loading="loadingexpress" icon="el-icon-edit" title="创建-快递单" size="mini"></el-button>
          </td>
          <td v-else>{{form.logisticsnum}}</td>
          <td align="right">发货时：</td>
          <td>{{btn=='填写发货单'?formatTime():controlData.handleoverdate}}</td>
        </tr>
        <tr class="noborder no-print" v-show="cangkujianhuo&&btn=='填写发货单'&&!isprint" style="height:26px">
          <td align="right">拣货人：</td>
          <td>
            <el-select v-model="form.pickuser" filterable placeholder="请选择拣货人" style="width: 135px;" size="mini">
              <el-option
                v-for="item in pickEmployees"
                :key="item.uguid"
                :label="item.uname"
                :value="item.uguid">
              </el-option>
            </el-select>
          </td>
          <td align="right">拣货审核：</td>
          <td colspan="3">
            <el-select v-model="form.pickaudituser" filterable placeholder="请选择拣货审核人" style="width: 135px;" size="mini">
              <el-option
                v-for="item in pickEmployees"
                :key="item.uguid"
                :label="item.uname"
                :value="item.uguid">
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr class="noborder" v-show="isshowyuandd" style="font-weight:bold;cursor:pointer"
            @click="lookDetails(controlData.sycstagreementDO)">
          <td align="right">原订单：</td>
          <td>{{controlData.parenterpserial}} <span v-if="controlData.sycstagreementDO.voucherdetailguid">铺货单</span></td>
          <td align="right">时 &nbsp;间：</td>
          <td>{{controlData.sycstagreementDO.adddate}}</td>
          <td align="right">状 &nbsp;态：</td>
          <td v-if="controlData.sycstagreementDO.status">{{controlData.sycstagreementDO.status}}
            <span style="color:red">{{controlData.sycstagreementDO.paymethod||''}}</span>
          </td>
        </tr>
        <tr class="noborder" v-show="!supplytaskid&&(form.scancodes==null||form.scancodes.length==0)&&!isprint&&(status==350&&btn=='填写发货单')">
          <td align="right">商品码：</td>
          <td>
            <el-input v-model="goodsbarcode" size="mini" @change="selectbarcode" ref="goodsbarcode" onfocus="this.select()" style="width: 125px"></el-input>
          </td>
          <td align="right"></td>
          <td></td>
          <td align="right"></td>
          <td>
            <span class="no-print" style="color: blue;cursor:pointer;margin-left: 10px"  @click="loadXYEXCEL()">导入发货数量</span>
            <input type="file" ref="fileupload1" style="display: none;" @change="afterFilesel($event)"/>
          </td>
        </tr>
        <tr v-if="isreturnorderEidt&&!isprint" class="noborder" style="font-weight:bold">
          <td align="right">退货原因</td>
          <td>
            <el-select v-model="controlData.returntype" placeholder="请选择" style="width: 135px;" size="mini"
                       @change="changereturntype">
              <el-option
                v-for="item in tuihuoyy"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </td>
          <td colspan="4">
            <el-input type="textarea" v-model="remark" :autosize="{ minRows: 1, maxRows: 1}"/>
          </td>
        </tr>
        <tr>
          <td colspan="6" style="border:none">
            <table v-if="!printhuiz" cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td v-if="noshowcolumn.indexOf(';'+item+';')==-1" :style="item=='数量'?'text-align: center;width: 60px':'text-align: center'" v-for="item in column">{{item=='数量'&&!hasFrame?(item+'(片)'):item}}</td>
                <td v-if="btn=='填写发货单'&&!isprint&&!isreturnorderEidt" style="text-align: center">发货数量</td>
                <td v-if="((printDisplay)||(showlookprice&&!isprint))&&!printBaiBao&&!isPrintOutStock&&tableData.length>0" style="text-align: center">单价</td>
                <td v-if="((printDisplay)||(showlookprice&&!isprint))&&!printBaiBao&&!isPrintOutStock&&tableData.length>0" style="text-align: center">总价</td>
              </tr>
              <!--表头结束-->
              <template v-for="(rows,id) in tableData">
              <tr style="cursor:pointer;">
                <td v-if="noshowcolumn.indexOf(';'+item+';')==-1" :style="{textAlign:item=='产品名称'?'left':'center',minWidth:item=='产品名称'?'90px':''}" v-for="item in column">
                 <el-checkbox :checked="true" :disabled="true" v-if="item=='是否坏件'&&isreturnorderEidt"></el-checkbox>
                  <div v-else @click="showDetail(rows)">
                    <div>{{getMapValue(rows,item)}}</div><!--v-if="(!printBaiBao&&item=='产品名称')||item!='产品名称'"-->
                    <div v-if="hasBaiBao&&(!isprint||printBaiBao)&&item=='产品名称'" v-html="getGuanLGoods(rows)"></div>
                  </div>
                </td>
                <td v-if="btn=='填写发货单'&&!isprint&&!isreturnorderEidt" style="text-align: center">
                  <input style="width:40px;" v-if="typeof(ob['发货数量']) !='undefined'" v-for="(ob,i) in rows"
                         :disabled="(form.scancodes.length>0||hasScancodeData)?true:false" v-model="ob['发货数量']" ref="id"/>
                </td>
                <td v-if="((printDisplay)||(showlookprice&&!isprint))&&!printBaiBao&&!isPrintOutStock&&tableData.length>0" style="text-align: center">
                  {{parseFloat(getMapValue(rows,'单价')||0).toFixed(2)}}
                </td>
                <td v-if="((printDisplay)||(showlookprice&&!isprint))&&!printBaiBao&&!isPrintOutStock&&tableData.length>0" style="text-align: center">
                  {{parseFloat(getMapValue(rows,'总价')||0).toFixed(2)}}
                </td>
              </tr>
                <!--计算小计-->
                <tr  v-if="showxiaoji&&addXiaoji(id)">
                  <td v-if="noshowcolumn.indexOf(';'+item+';')==-1" style="text-align: left;font-size: 11pt" v-for="item in column">
                    <span style="font-size: larger"><b>{{item=='产品名称'?'小计':(item=='数量'?addXiaoji(id)['数量']:'')}}</b></span>
                  </td>
                  <td v-if="btn=='填写发货单'&&!isprint&&!isreturnorderEidt"></td>
                  <td v-if="((printDisplay)||(showlookprice&&!isprint))&&!printBaiBao&&!isPrintOutStock&&tableData.length>0"></td>
                  <td v-if="((printDisplay)||(showlookprice&&!isprint))&&!printBaiBao&&!isPrintOutStock&&tableData.length>0" style="text-align: center;">
                    <span style="font-size: larger"><b>{{addXiaoji(id)['总价'].toFixed(2)}}</b></span>
                  </td>
                </tr>
                <tr  v-if="showxiaoji&&addXiaoji(id)">
                  <td style="border:0px solid #000000;line-height: 30px;height: 30px">&nbsp;</td>
                </tr>
                <!--小计结束-->
              </template>
              <!--表内容行结束-->
              <tr>
                <td v-if="noshowcolumn.indexOf(';'+item+';')==-1" v-for="(item,index) in column" style="text-align: center" >
                  <span v-if="item=='产品名称'">合计</span>
                  <span v-if="item=='数量'">{{totalnumber}}</span>
                </td>
                <td v-if="btn=='填写发货单'&&!isprint&&!isreturnorderEidt" style="text-align: center">{{fahuonumber}}</td>
                <td v-if="((printDisplay)||(showlookprice&&!isprint))&&!printBaiBao&&!isPrintOutStock&&tableData.length>0"></td>
                <td v-if="((printDisplay)||(showlookprice&&!isprint))&&!printBaiBao&&!isPrintOutStock&&tableData.length>0" style="text-align: center">{{totalmoney.toFixed(2)}}
                </td>
              </tr>
            </table>
            <table v-if="printhuiz" cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td style="text-align: center">产品名称</td>
                <td :style="item=='数量'?'text-align: center;width: 60px':'text-align: center'">数量{{!hasFrame?'(片)':''}}</td>
                <td v-if="((printDisplay)||(showlookprice&&!isprint))&&!isPrintOutStock&&tableData.length>0" style="text-align: center">单价</td>
                <td v-if="((printDisplay)||(showlookprice&&!isprint))&&!isPrintOutStock&&tableData.length>0" style="text-align: center">总价</td>
              </tr>
              <template v-for="(rows,id) in tableData">
                <tr  v-if="addXiaoji(id)">
                  <td>{{getMapValue(rows,'产品名称')}}</td>
                  <td style="text-align: center;">{{addXiaoji(id)['数量']}}</td>
                  <td v-if="((printDisplay)||(showlookprice&&!isprint))&&!isPrintOutStock&&tableData.length>0" style="text-align: center;">
                    {{(addXiaoji(id)['总价']/addXiaoji(id)['数量']).toFixed(2)}}
                  </td>
                  <td v-if="((printDisplay)||(showlookprice&&!isprint))&&!isPrintOutStock&&tableData.length>0" style="text-align: center;">
                   {{addXiaoji(id)['总价'].toFixed(2)}}
                  </td>
                </tr>
                <!--小计结束-->
              </template>
              <!--表内容行结束-->
              <tr>
                <td style="text-align: center">合计</td>
                <td style="text-align: center">{{totalnumber}}</td>
                <td v-if="((printDisplay)||(showlookprice&&!isprint))&&!isPrintOutStock&&tableData.length>0" style="text-align: center"></td>
                <td v-if="((printDisplay)||(showlookprice&&!isprint))&&!isPrintOutStock&&tableData.length>0" style="text-align: center">{{totalmoney.toFixed(2)}}
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6" style="height: 10px"></td>
        </tr>
        <tr class="noborder" v-if="!isPrintOutStock">
          <td align="right">说&nbsp;&nbsp;明：</td>
          <td colspan="5" style="border: none;height: 30px">
            <div v-html="getLiuYan(controlData.remark)">
            </div>
          </td>
        </tr>
        <tr class="noborder" v-if="!isPrintOutStock">
          <td colspan="6" style="border:none">
            <div style="float: left" v-for="(item,index) in parameter" v-if="item&&index.indexOf('优化')==-1">
              <span style="width:90px;display: inline-block;text-align: right">
              {{index+"："}}</span>
              <span style="min-width:70px;display: inline-block;text-align: left">{{item}}</span>
            </div>
          </td>
        </tr>
        <tr class="noborder" v-if="isreturnorderEidt&&!isprint">
          <td align="right">处&nbsp;&nbsp;&nbsp;&nbsp;理：</td>
          <td colspan="3">
            <el-input type="textarea" v-model="cangkutuihuoremark" :autosize="{ minRows: 2, maxRows: 2}"/>
          </td>
        </tr>
        <tr class="noborder" v-if="isreturnorderEidt&&status==655&&!isprint&&controlData.sycstagreementDO.status=='待发货'">
          <td colspan="4" style="padding-top: 10px">
            <span>&nbsp;&nbsp;已下单供应商：</span>
            <el-radio-group v-model="form.orderopinion">
              <el-radio :label="1">拦截成功</el-radio>
              <el-radio :label="-1">拦截失败</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr class="noborder" style="height:26px" v-if="!isPrintOutStock">
          <td colspan="2">&nbsp;&nbsp;&nbsp;开单人员：{{controlData.ssfzr||""}}</td>
          <td colspan="4"><div  style="float: left;width:140px">出库人员：{{controlData.handleoveruname||""}}</div>
             <div v-if="!isshowyuandd&&!printBaiBao" style="padding-right: 30px;float: left;">支付方式：{{controlData.paymethod||""}}</div>
            <span v-if="!isshowyuandd&&((printDisplay)||(showlookprice&&!isprint))&&!printBaiBao" style="font-size: larger;float: left">总额：<b>{{subtotalmoney.toFixed(2)}}</b></span>
            <span v-else>&nbsp;</span>
          </td>
        </tr>
        <tr class="noborder" style="height:15px">
          <td colspan="6">&nbsp;</td>
        </tr>
        <tr class="noborder" style="height: 26px">
          <td align="right">GZ.NO：</td>
          <td>
            <el-input v-model="form.logisticstracknum" size="mini" ref="logisticstracknum" placeholder="请填写跟踪单号"
                      v-if="btn=='填写发货单'&&!isprint"
                      onfocus="this.select()"
                      @change="updateTracknumField('logisticstracknum')"
                      style="width: 125px"></el-input>
            <span v-if="btn!='填写发货单'||isprint">{{form.logisticstracknum}}</span>
          </td>
          <td align="right">GY.NO：</td>
          <td colspan="3">
            <a @click="showSupplyOrder()" style="cursor: pointer;color: dodgerblue"
               v-if="form.tracknum&&controlData.tracknum.length>=14&&form.tracknum.substr(0,2)=='42'">{{form.tracknum}}</a>
            <a v-else>
              <el-input v-model="form.tracknum" size="mini" ref="tracknum" placeholder="请填写供应号" v-if="btn=='填写发货单'&&!isprint" onfocus="this.select()"
                                                                                          @change="updateTracknumField('tracknum')"
                                                                                          style="width: 250px"></el-input>
              <span v-if="btn!='填写发货单'||isprint">{{form.tracknum}}</span>
            </a>
            <span v-if="!isprint&&supplystatuslist.length>0" @click="supplydrawer=true" style="padding-left: 20px;cursor: pointer;font-size: larger;">
              <b>{{supplystatuslist[supplystatuslist.length-1].FlagCode}}</b>
            </span>
            <el-drawer v-if="supplystatuslist.length>0" :withHeader="false" :modal="false"
              title="订单状态"
              :visible.sync="supplydrawer" :wrapperClosable="true" :append-to-body="true"
              :direction="'rtl'">
              <el-table
                :data="supplystatuslist"
                size="mini"  :height="tableHeight(-60)"
                stripe
                border
                style="width: 100%;">
                <el-table-column
                  label="步骤" prop="FlagCode"
                  align="left"
                  header-align="center" >
                </el-table-column>
                <el-table-column
                  label="时间" prop="FlagDateTime"
                  align="left" width="140px"
                  header-align="center">
                </el-table-column>
              </el-table>
            </el-drawer>
            <span v-if="isprint" style="padding-right: 20px;float: right;" v-html="printday"></span>
          </td>
        </tr>
        <tr class="noborder" style="height:26px">
          <td align="right">服务商：</td>
          <td v-if="isNoshow">{{pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle}}</td>
          <td v-else>{{controlData.applybydname}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.address}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.elinkman||"")+" "+(controlData.elinkmantel||"")}}</td>
        </tr>
      </table>
      <!--展示已成交中的退货订单信息-->
      <div style="textAlign:center;fontSize:18px;lineHeight:40px;margin-top: 2px;color: red" v-if="isycjorder">
        退货单
      </div>
      <div style="border:1px solid red;width: 640px;padding-left: 15px" v-if="isycjorder">
        <table v-for="(item,indextable) in this.tuihuoorders"
               style="border-collapse:collapse;width:620px;margin-top: 20px">
          <tr class="noborder">
            <td align="left" width="10%">销售单号：</td>
            <td align="left" width="20%">{{item.erpserial}}</td>
            <td align="left" width="10%">下单日期：</td>
            <td align="left">{{item.adddate}}</td>
            <!--<td align="left" width="80">应交付日期：</td>-->
            <!--<td align="left">{{item.jhjgrq}}</td>-->
          </tr>
          <tr>
            <td colspan="6" style="border:none">
              <table cellspacing="0" cellpadding="0" border="0"
                     style="border-collapse:collapse;width:100%;fontSize:'18px'"
                     class="query-table">
                <tr>
                  <td v-if="item !='seedcode' && item !='unitguid'" style="text-align: center"
                      v-for="item in item['tuihuocolumn']">
                    {{item}}
                  </td>
                </tr>
                <tr v-for="(item,index) in item['billmap']" style="cursor:pointer;">
                  <td
                    :style="{textAlign:ob['产品名称']?'left':'center',minWidth:ob['产品名称']?'150px':''}"
                    v-for="(ob,index) in item" v-if="index!=0">
                    <span v-for="value in ob" v-if="index!=0">{{value}}</span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr class="noborder">
            <td>说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
            <td colspan="5" style="text-align: left">
              <div v-html="getLiuYan(item.remark)"></div>
            </td>
          </tr>
          <tr v-if="indextable != tuihuoorders.length-1">
            <td colspan="6">
              <div id=content style="border:1px dashed #334455;width: 100%"></div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer no-print" v-if="!noModal">
      <template v-if="returnorderpercent&&isreturnorderEidt&&returnorderpercent>0">
        退货率：<span v-if="returnorderpercent>=10" style="color: red;font-size: x-large"><b>{{returnorderpercent}}</b></span>
        <span v-else style="color: black;font-size:x-large"><b>{{returnorderpercent}}</b></span>%
      </template>
      <el-button @click="dialogSeeVisible = false" size="mini">取 消</el-button>
      <el-button @click="changePackage" type="success" plain v-if="status==200&&flage"  size="mini">修改商品</el-button>
      <el-button @click="inputBatch" type="success" plain  size="mini" v-if="false&&!supplytaskid&&(btn=='填写发货单'||status==500||status==400)">录入批号</el-button>
      <template v-if="isreturnorderEidt">
        <el-button type="danger" @click="saveReturnOrder" v-if="returnorderpercent&&returnorderpercent>=10&&status==660" :loading="loading">转销售确认</el-button>
        <el-button type="primary" @click="saveReturnOrder" v-else :loading="loading">同意退货</el-button>
      </template>
      <el-button type="success" @click="delivergoodsScan" class="qrbtn" v-if="btn=='填写发货单'&&!hasScancodeData&&(supplytaskid||qrcodescan||form.scancodes.length>0)" :loading="loading">扫码发货</el-button>
      <el-button type="success" @click="delivergoodsFast" class="qrbtn" v-if="btn=='填写发货单'&&supplytaskid" :loading="loading">DMS已扫</el-button>
      <el-button type="success" @click="viewScancodes" size="mini" class="qrbtn" v-if="btn=='填写发货单'&&hasScancodeData&&!supplytaskid&&form.scancodes.length==0">商品条码</el-button>
      <el-button type="success" @click="delivergoodsScan" size="mini" class="qrbtn" v-if="!supplytaskid&&(controlData.status==500||controlData.status==400)">商品条码</el-button>
      <el-button type="primary" @click="delivergoodsScanRe" size="mini" class="qrbtn" v-if="supplytaskid&&(status==500||status==400)">补扫物流码</el-button>
      <el-button type="primary" @click="delivergoods" class="qrbtn" v-if="!supplytaskid&&btn=='填写发货单'" :loading="loading">确认出库</el-button>
      <el-button type="primary" @click="erchidelivergoods" class="qrbtn" v-if="!supplytaskid&&btn=='邮寄'&&status==400" :loading="loading">确认发货</el-button>
      <template v-if="!loading||xinyoneduprint">
      <el-button type="info" @click="printOutStock" v-if="printoutstock&&status==350" size="mini">缺货单</el-button>
      <el-button type="info" @click="printPre(1)" v-if="(roletype!='order'&&status!=200)||isFrame||order200print" size="mini">打印</el-button>
      <el-button type="info" @click="printPre(2)" v-if="((roletype!='order'&&status!=200)||isFrame||order200print)&&!hasBaiBao&&printDisplay" size="mini">打印(无价格)</el-button>
      <el-button type="info" @click="printPre(3)" v-if="roletype!='order'&&status!=200&&!hasBaiBao&&!isFrame" size="mini">汇总单</el-button>
      <el-button type="info" @click="pickupPrint" v-if="status==350&&printpickup" size="mini">拣货单</el-button>
      <el-button type="info" @click="printBox()" v-if="roletype!='order'&&status!=200&&!hasBaiBao&&!isFrame&&showboxsticker" size="mini">盒贴</el-button>
      <el-dropdown style="margin-left: 5px" @command="handlePrintLabel" v-if="roletype!='order'&&status!=200&&!hasBaiBao&&!isFrame&&printbacksticker">
        <el-button type="info" size="mini">
          包装标签<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" style="font-size: larger">
          <el-dropdown-item command="backP">后标签（单片）</el-dropdown-item>
          <el-dropdown-item command="preP">前标签（单片）</el-dropdown-item>
          <el-dropdown-item command="packageP">包装袋（单片）</el-dropdown-item>
          <el-dropdown-item command="back" divided>后标签</el-dropdown-item>
          <el-dropdown-item command="pre">前标签</el-dropdown-item>
          <el-dropdown-item command="package">包装袋</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="info" @click="printPre(4)" v-if="roletype!='order'&&status!=200&&!hasBaiBao&&printDisplay&&!isFrame" size="mini">汇总(无价格)</el-button>
      <el-button type="info" @click="loadframeexcel()" v-if="roletype!='order'&&status!=200&&isFrame" size="mini">导出</el-button>
      <el-dropdown style="margin-left: 20px" @command="handleDropCommand" v-if="roletype!='order'&&status!=200&&hasBaiBao">
        <el-button type="info" icon="el-icon-printer" :loading="loading" size="mini">
          打印模板
        </el-button>
        <el-dropdown-menu slot="dropdown" style="font-size: larger">
          <el-dropdown-item command="sale">销货单</el-dropdown-item>
          <el-dropdown-item command="salenoprice">销货单(无价格)</el-dropdown-item>
          <el-dropdown-item command="salesub">销货汇总单</el-dropdown-item>
          <el-dropdown-item command="saleempty">取货单</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      </template>
      <span v-if="!isreturnorderEidt" @click="printloglook" style="position: absolute;bottom: 8px;right: 10px">{{tips()}}</span>
      <span v-if="!isreturnorderEidt" @click="handleloglook" style="position: absolute;bottom: 25px;right: 10px">处理日志</span>
    </div>

    <CstagreementEditSeedDetail ref="seeddetail" @shuxiprint="shuxiprint"></CstagreementEditSeedDetail>
    <UpdateAddress ref="UpdateAddress" @afertupdate="afertupdate"></UpdateAddress>
    <StoreEdit ref="StoreEdit" @afertupdatecangku="afertupdatecangku"></StoreEdit>
    <printlogList ref="printlogList"></printlogList>
    <HandlelogList ref="HandlelogList"></HandlelogList>
    <PickupPrint ref="pickupprint"></PickupPrint>
    <Printtitle ref="Printtitle" @printtitlename="printtitlename"></Printtitle>
    <BuyfromList ref="BuyfromList"></BuyfromList>
    <ScanCodeBatch ref="ScanCodeBatch" @scancodeedit="scancodeloadBatch" @clearscancode="scancodeloadBatch"></ScanCodeBatch>
    <ScanCodeSupplyer ref="ScanCodeSupplyer" @scancodeedit="scancodeloadSupply"></ScanCodeSupplyer>
    <ScanCodeSupplyer ref="ScanCodeSupplyerCopy" @scancodeedit="scancodeloadSupplyCopy"></ScanCodeSupplyer>
    <editPackage ref="editPackage" @reflashInit="reflashInit"></editPackage>
    <UpdateExpressFee ref="UpdateExpressFee1" @afterUpdateExpressFee="afterUpdateExpressFee"></UpdateExpressFee>
    <Boxsticker ref="Boxsticker1"></Boxsticker>
    <LensLabelPrint ref="lensLabelPrint"></LensLabelPrint>
    <JxcgooddetailSel ref="JxcgooddetailSel1" :hassaleprice="true" :showtree="false" @afterSelectCode="afterSelectMachinecode"></JxcgooddetailSel>
    <!-- 补加工单数量弹窗 -->
    <el-dialog title="加工数量" :visible.sync="machiningQtyDialogVisible" center :close-on-click-modal="false" :append-to-body="true" width="30%">
      <el-form>
        <el-form-item label="加工项">
          <span style="font-weight:bold">{{selectedMachineRow?selectedMachineRow.seedname:''}}</span>
        </el-form-item>
        <el-form-item label="数量">
          <el-input-number v-model="machiningQty" :min="1" :precision="0" controls ref="machiningQtyInput" @focus.native="handleMachiningQtyFocus" style="width: 200px"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="machiningQtyDialogVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmMachiningQty">确定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
    <SplitOrderPrint ref="splitOrderPrint"></SplitOrderPrint>
  </div>
</template>

<script>
  import {
    printing,
    returnGoodsUpdate,
    ispsq,
    multipleShipments,
    addMachineOrder,
    pickingUp,
    checkprinting,updateExpressFee,getBackpercent,ercifahuo,
    deliveryOver,
    saveCstagreementData,
    getPrintLabelData
  } from '@/api/set/csagreement';
  import UpdateExpressFee from './UpdateExpressFee';
  import CstagreementEditSeedDetail from './CstagreementEditSeedDetail'
  import Printtitle from './Printtitle'
  import UpdateAddress from './UpdateAddress'
  import printlogList from './printlogList'
  import HandlelogList from './HandlelogList'
  import JxcgooddetailSel from '../../set/jxcgooddetail/JxcgooddetailSel';
  import {getRemark, getKHRemark} from '@/plugin/ordercommon'
  import BuyfromList from '@/components/testorder/buyagreement/BuyfromList'
  import {getParameterDetail} from '@/api/set/parameter';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {getDuiZhangCus} from '@/api/voucher/accountresultbz';
  import {save, getStoreNum} from '@/api/order/printlog';
  import StoreEdit from './StoreEdit';
  import {saveData} from '@/api/set/handlelog';
  import {getListData} from '@/api/set/employee';
  import {exportExcel,exportExcelV2} from '@/api/file';
  import {sfOrderService, sfOrderConfirm,sfRouteService,sfOrderPrint,loadPrintFile} from '@/api/order/express';
  import {getModuleRight} from '@/api/login'
  import ScanCodeBatch from '@/components/testorder/cstagreement/ScanCodeBatch';
  import ScanCodeSupplyer from '@/components/testorder/cstagreement/ScanCodeSupplyer';
  import editPackage from '@/components/testorder/cstagreement/editPackage';
  import {getDetail, batchSave, listByInordernum} from '@/api/set/jxcstoregoodsbarcode';
  import {bardetail} from '@/api/set/jxcgoodsbarcode';
  import Boxsticker from './Boxsticker'
  import LensLabelPrint from './LensLabelPrint'
  import PickupPrint from './PickupPrint'
  import SplitOrderPrint from './SplitOrderPrint'
  import {getdescreMul} from "../../../api/set/jxcgooddetail";

  export default {
    name: 'CstagreementEdit',
    props: {
      noModal: { type: Boolean, default: false },
      customClass: { type: String, default: '' },
      appendToBody: { type: Boolean, default: true },
      showOnlyPrintOutstock: { type: Boolean, default: false }
    },
    data() {
      return {
        loading:false,
        loadingexpress:false,
        pagetitle: '',
        xinyoneduprint:true,
        printday: '',
        showscantable:true,
        supodderrequired:false,
        imgpath: '',
        linecredit:'',
        ticket:'',
        daiGuansend:false,
        pageinit:{},
        imgLogURL:'',
        imgLogURLSet:'',
        returnorderpercent:'',
        jiagongimgpath: '',//加工单条形码
        userInfoModel: {},
        flage: true,
        isFrame:false,
        showboxsticker:false,
        printbacksticker:false,
        printLabelLoading: false,
        dialogSeeVisible: false,
        order200print:false,
        hasBaiBao:false,
        changeBaibao:false,
        printBaiBao:false,
        hasFrame:false,
        formLabelWidth: '120px',
        batchbarcode:[],
        noprintbutton:false,
        printhuiz:false,
        isprint: false,
        showxiaoji:false,
        seedsub:[],
        showlookprice: false,
        noshowcolumn:';unitguid;seedcode;packagesize;formproperty;关联产品;subseedcode;总价;单价;发货数量;',
        groupguid: '',
        seedcode: "",
        tableData: [],
        printData: [],//打印日志
        uname: '',//最新一条打印人员
        adddate: '',//最新一条打印时间
        unitguid: "",
        remark: "",
        remarkselection: '',
        cangkutuihuoremark: '',
        column: [],
        tuihuocolumn: [],
        controlData: {
          sycstagreementDO: {}, cstagreementDOList: []
        },
        showtitle1: "none",
        parameterData: [],
        isshowyuandd: false,
        supplytaskid:'',
        isreturnorderEidt: false,
        deliveryaddress: '',
        tuihuoyy: [],
        tuihuoorders: [],
        isycjorder: false,
        remarktype: '',
        buyinfo: {},
        //发货方式
        options: [{
          value: '500',
          label: '直发客户'
        }, {
          value: '400',
          label: '发服务中心'
        }],
        isShowAdressAndCangkuUpdate: true,
        form: {
          erpserial: "",
          deliverymode: 10,
          logisticsco: '',
          logisticsnum: '',
          customername: '',
          jxcformdetaillist: '',
          customerserial: '',
          independentserial: '',
          cangkucode: '',
          cangkuname: '',
          origionstatus: '',
          jxcformDetailDo: '',
          isdistribute: '',
          formtype: '',
          orderopinion: '',
          eliverydStatus: '',
          storegoodsbarcode: '',//库存商品唯一条码
          logisticstracknum: '',//跟踪单号
          tracknum:'',
          pickuser: '',//拣货人
          pickaudituser: '',//拣货审核人
          invoicesource: 0,
          scancodes: [],//仓库发货扫唯一码
        },
        formLabelWidth: '120px',
        hasScancodeData: false,//填写发货单时查询到已有扫码记录
        scancodeLoading: false,//扫码记录加载中
        jxcstoreData: [],
        parameter: {},
        supplystatuslist:[],
        supplydrawer:false,
        btn: '',
        status: '',
        totalnumber: 0,
        totalmoney: 0,
        subtotalmoney:0,
        storescan: '',//是否支持扫码出入库
        storescanSys:'',
        goodsbar: [],
        caiGouRukuData: [],//出库条码
        storebarcode: [],//所有库存唯一条码
        goodsbarcode: '',//商品条码
        handlelogData: [],//处理日期
        drawer: '',//开单人
        printDisplay: false,//打印是否显示价格
        roletype: '',//岗位类型
        onlyonecode: '',//唯一码
        isNoshow: false,//是否需要更换服务商
        goodsDetail:[],
        seedList:[],
        aftermachineadd:false,
        printoutstock:false,
        isPrintOutStock:false,
        printpickup:false,
        qrcodescan:false,
        cangkujianhuo:false,//拣货管理：填写发货单时需选择拣货人/拣货审核人
        pickEmployees: [],//拣货人候选列表
        binallocationRight:false,
        storenum:0,
        hasStoreNum:false,//该订单是否已生成过库位号（已生成过则补打印不再写入storenum，避免污染当天max）
        machiningQtyDialogVisible:false,
        selectedMachineRow:null,
        machiningQty:1,
      }
    },
    methods: {
      /**
       * 跟踪单号/供应号修改后即时更新到数据库
       */
      updateTracknumField(field) {
        var value = this.form[field] ? this.form[field].trim() : '';
        var params = {
          unitguid: this.controlData.unitguid,
          erpserial: this.controlData.erpserial
        };
        params[field] = value;
        saveCstagreementData(params).then(response => {
          if (response.data.code == 0) {
            this.controlData[field] = value;
          }
        });

        if (this.buyinfo && this.buyinfo.unitguid) {
          params.unitguid = this.buyinfo.unitguid;
          params.erpserial = this.buyinfo.erpserial;
          saveCstagreementData(params).then(response => {
          });
        }
      },
      handleDropCommand(command) {
        if (command == 'salenoprice') {
          this.printPre(2);
          return;
        } else if (command == 'salesub') {
          this.printPre(3);
          return;
        }
        this.loading = true;
        var needSetCode = []
        var seeds = '';
        for (let i in this.controlData.goodsdetail) {
          var exist = false;
          var existSub = false;
          for (let j in this.seedList) {
            if (this.seedList[j].seedcode == this.controlData.goodsdetail[i].seedcode) {
              exist = true;
            }
            if (this.controlData.goodsdetail[i].subseedcode && this.seedList[j].seedcode == this.controlData.goodsdetail[i].subseedcode) {
              existSub = true;
            }
          }
          if (!exist) {
            var arr = {seedcode: this.controlData.goodsdetail[i].seedcode, sign: [], barcode: []};
            seeds += arr.seedcode + ';';
            this.seedList.push(arr);
            needSetCode.push(arr)
          }
          if (this.controlData.goodsdetail[i].subseedcode && !existSub) {
            var arr = {seedcode: this.controlData.goodsdetail[i].subseedcode, sign: [], barcode: []};
            seeds += this.controlData.goodsdetail[i].subseedcode + ';';
            this.seedList.push(arr);
            needSetCode.push(arr)
          }
        }

        if (seeds) {
          getdescreMul({seedcode: seeds}).then(response => {
            var sign = response.data.sign;
            var barcode = response.data.barcode;
            var goods = response.data.goods;//filltemplate

            for (let i in needSetCode) {
              for (let j in sign) {
                if (sign[j].goodsguid == needSetCode[i].seedcode) {
                  if (sign[j].signs) {
                    needSetCode[i].signs = sign[j].signs;
                  }
                  break;
                }
              }

              for (let j in goods) {
                if (goods[j].seedcode == needSetCode[i].seedcode) {
                  needSetCode[i].filltemplate = goods[j].filltemplate;
                  break;
                }
              }

              for (let j in barcode) {
                if (barcode[j].seedcode == needSetCode[i].seedcode) {
                  if (barcode[j]) {
                    needSetCode[i].barcode.push(barcode[j]);
                  }
                }
              }
            }

            this.printD(command);
          });
        }
        else {
          this.printD(command);
        }
      },
      printD(command) {
        if (command == 'sale') {
          this.loading = false;
          this.print1(false, 1)
          return;
        } else if (command == 'saleempty') {
          this.loading = false;
          this.print1(true, 5)
          return;
        }
      },
      addXiaoji(index) {
        for (let i in this.seedsub) {
          if (this.seedsub[i].index == index)
            return this.seedsub[i];
        }
        return null;
      },
      showupdateExpressFee() {
        this.$refs.UpdateExpressFee1.show(this.controlData.expressfee);
      },
      //修改运费之后的回调方法
      afterUpdateExpressFee(expressfee) {
        updateExpressFee({
          unitguid: this.controlData.unitguid,
          expressfee: Math.abs(expressfee)
        }).then(response => {
          if (response.data.code == 0) {
            this.$message({
              type: 'success',
              duration: 1500,
              message: '操作成功!'
            });
            this.controlData.expressfee = Math.abs(expressfee)
            this.subtotalmoney = parseFloat(this.totalmoney) + parseFloat(this.controlData.expressfee);
          } else {
            this.$message.error('操作失败')
          }
        })
      },
      changePackage() {//调整光度
        this.$refs.editPackage.show(this.controlData, this.goodsDetail, this.parameter);
      },
      inputBatch() {
        this.$refs.ScanCodeBatch.show({
          issale: true,
          erpserial: this.controlData.erpserial,
          billmap: this.goodsDetail
        }, this.form.scancodes, this.btn == '填写发货单');
      },
      showSupplyOrder() {//显示供应商系统中的订单
        this.$refs.BuyfromList.show(this.controlData.tracknum, this.controlData.pcustomerserial);
      },
      getMapValue(ol, col) {
        var ret = '';
        for (let j = 0; j < ol.length; j++) {
          if (ol[j].hasOwnProperty(col))
            ret = ol[j][col];
        }
        return ret;
      },
      getGuanLGoods(rows) {
        var goods = this.getMapValue(rows, '关联产品');
        if (goods) {
          return '<div style="float: left;padding-left: 20px">' + goods + '</div>'
        }
        return '';
      },
      setMapValue(ol, col, val) {
        var hasV = false;
        for (let j = 0; j < ol.length; j++) {
          if (ol[j].hasOwnProperty(col)) {
            hasV = true
            ol[j][col] = val;
          }
        }
        if (!hasV)
          ol.push({col: val});
      },
      //查看已扫码的商品条码（复用现成ScanCodeSupplyer组件只读查看，isshowqr=false会再查数据）
      viewScancodes() {
        this.$refs.ScanCodeSupplyer.show({
          issale: true,
          cangkucode: this.form.cangkucode,
          erpserial: this.controlData.erpserial,
          billmap: this.goodsDetail,
          supplytaskid: this.supplytaskid,
          pcustomerserial: this.controlData.pcustomerserial,
          buyerpserial: this.buyinfo ? this.buyinfo.erpserial : '',
          tracknum: this.form.tracknum,
          qrcodescan: this.qrcodescan,
          allscan: false
        }, this.form.scancodes, false);
      },
      delivergoodsScan() {//扫码发货
        //操作前先情况发货数量
        for (let g = 0; g < this.tableData.length; g++) {
          var arr = this.tableData[g];
          this.setMapValue(arr, '发货数量', 0);
        }
        this.$refs.ScanCodeSupplyer.show({
          issale: true,
          cangkucode: this.form.cangkucode,
          erpserial: this.controlData.erpserial,
          billmap: this.goodsDetail,
          supplytaskid: this.supplytaskid,
          pcustomerserial: this.controlData.pcustomerserial,
          buyerpserial: this.buyinfo ? this.buyinfo.erpserial : '',
          tracknum: this.form.tracknum,
          qrcodescan: this.qrcodescan,
          allscan: this.controlData.status == 500 || this.controlData.status == 400//必须全部扫码
        }, this.form.scancodes, this.btn == '填写发货单');
      },
      delivergoodsScanRe() {
        this.$refs.ScanCodeSupplyerCopy.show({
          issale: true,
          cangkucode: this.form.cangkucode,
          erpserial: this.controlData.erpserial,
          billmap: this.goodsDetail,
          supplytaskid: this.supplytaskid,
          pcustomerserial: this.controlData.pcustomerserial,
          batchbarcode: this.batchbarcode,
          allscan: true//必须全部扫码
        }, this.form.scancodes, true);
      },
      scancodeloadSupply(scancodes) {//同步发货
        for (let g = 0; g < this.tableData.length; g++) {
          var arr = this.tableData[g];
          var packagesize = this.getMapValue(arr, 'packagesize')
          if (!packagesize) {//非镜片自动填上发货数量
            var shuliang = parseInt(this.getMapValue(arr, '数量'));
            this.setMapValue(arr, '发货数量', shuliang);
          }
        }
        this.scancodeloadBatch(scancodes);
        this.delivergoods();
      },
      scancodeloadSupplyCopy(scancodes) {//重推物流码 不需要发货 (啥都不执行)
        //this.$refs.ScanCodeSupplyerCopy.postPurchaseIn();//触发供应商出入库
      },
      //唯一码扫码数量
      scancodeloadBatch(scancodes) {
        this.form.scancodes = scancodes;
        if (this.showscantable && !this.supplytaskid) {
          this.showscantable = false;
        }
        //bcode是唯一码的数量
        for (let g = 0; g < this.tableData.length; g++) {
          var arr = this.tableData[g];

          var seedcode = this.getMapValue(arr, 'seedcode')
          var packagesize = this.getMapValue(arr, 'packagesize')
          if (!packagesize)
            continue;

          var shuliang = parseInt(this.getMapValue(arr, '数量'));
          var num = 0;
          var HasInit = false;
          if (!HasInit && !this.supplytaskid) {
            for (let j = 0; j < scancodes.length; j++) {
              if (!scancodes[j].hasuse && scancodes[j].seedcode == seedcode && scancodes[j].packagesize == packagesize && scancodes[j].storegoodsbarcode) {
                num += 1;

                HasInit = true;
                scancodes[j].hasuse = true
                if (num >= shuliang)
                  break;
              }
            }
          } else {
            var scanC = scancodes.filter(o => o.seedcode == seedcode && o.packagesize == packagesize && o.storegoodsbarcode && !o.hasuse);
            num = scanC ? scanC.length : 0;
            if (num > shuliang) {
              num = shuliang;
            }
            for (let j = 0; j < num; j++) {
              scanC[j].hasuse = true;
            }
          }
          if (this.btn == '填写发货单')
            this.setMapValue(arr, '发货数量', num);
        }
      },
      loadXYEXCEL() {
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },
      afterFilesel() {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              let arr = []
              let obj = {}
              data.forEach((item) => {
                let Y = ""
                for (let X in item) {
                  obj = {}
                  if (X == "球\\柱") {
                    Y = parseFloat(item[X]).toFixed(2)
                  } else {
                    if (typeof parseFloat(item[X]) === 'number' && !isNaN(parseFloat(item[X]))) {
                      obj = {
                        packagesize: '{"X":"' + parseFloat(X).toFixed(2) + '","Y":"' + Y + '"}',
                        number: parseInt(item[X])
                      }
                      arr.push(obj)
                    }
                  }
                }
              })

              for (let g = 0; g < this.tableData.length; g++) {
                var item = this.tableData[g];
                var seedcode = this.getMapValue(item, 'seedcode')
                var packagesize = this.getMapValue(item, 'packagesize')
                if (!packagesize)
                  continue;
                var num = 0;
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].packagesize == packagesize && arr[j].number > 0) {
                    num = arr[j].number;
                    arr[j].number = 0;
                    break;
                  }
                }
                this.setMapValue(item, '发货数量', num);
              }
            }
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      selectbarcode(val) {
        if (!val)
          return;
        if (this.form.scancodes.length > 0) {
          this.$alert('请扫唯一码!', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'warning',
                message: '请扫唯一码！'
              })
            }
          });
          this.goodsbarcode = '';
          this.$refs.onlyonecode.focus();
          return
        }
        this.goodsbarcode = '';
        this.form.storegoodsbarcode = ''
        var obj = {
          barcode: val
        }
        bardetail(obj).then(response => {
          this.goodsbar = response.data.obj
          //商品不存在提示
          if (this.goodsbar == undefined) {
            this.$message({
              message: '条码无效',
              type: 'error'
            })
            return
          } else {
            if (this.tableData.length > 0) {
              var count = 0
              var RLcount = 0
              var seedname = '';//商品名称
              var packagesize = '';//商品光度
              var count = 0//判断是否已达上限
              var compare = false//判断是否存在商品码
              for (let i in this.tableData) {
                var ol = this.tableData[i];
                // this.tableData.map(o1 => {
                var seedcode = this.getMapValue(ol, 'seedcode')
                seedname = this.getMapValue(ol, '产品名称')
                var Y = this.getMapValue(ol, '球镜')
                var X = this.getMapValue(ol, '柱镜')
                var shuLiang = Math.abs(this.getMapValue(ol, '数量'))
                var fh = this.getMapValue(ol, '发货数量');
                if (!fh) fh = 0;
                var fhShuLiang = parseInt(fh)
                //商品编码 没有光度条码  只需要判断商品编码是否一样
                if (this.goodsbar.filltemplate == 40) {
                  if (seedcode == this.goodsbar.seedcode) {
                    //判断商品数量大于扫描数量加1,否则继续向下循环
                    compare = true
                    if (shuLiang > fhShuLiang) {
                      //商品条码
                      this.goodsbar.goodsbarcode = this.goodsbar.barcode
                      //仓库编码
                      this.goodsbar.cangkucode = this.controlData.cangkucode
                      //采购单编码
                      this.goodsbar.buyordernum = this.controlData.erpserial
                      ++count;
                      break;
                      // this.$refs.storegoodsbarcode.focus()
                    }
                  }
                } else if (seedcode == this.goodsbar.seedcode && Number(X) == Number(JSON.parse(this.goodsbar.packagesize).X) && Number(Y) == Number(JSON.parse(this.goodsbar.packagesize).Y)) {

                  //商品编码、光度一样需要一样
                  //判断商品数量大于扫描数量加1,否则继续向下循环
                  compare = true
                  if (this.goodsbar.filltemplate == 20 || this.goodsbar.filltemplate == 30) {
                    packagesize = "{球镜：" + JSON.parse(this.goodsbar.packagesize).Y + ",柱镜：" + JSON.parse(this.goodsbar.packagesize).X + ",type:" + (JSON.parse(this.goodsbar.packagesize).type == undefined ? '' : JSON.parse(this.goodsbar.packagesize).type) + "}"
                  } else {
                    packagesize = "{球镜：" + JSON.parse(this.goodsbar.packagesize).Y + ",柱镜：" + JSON.parse(this.goodsbar.packagesize).X + "}"
                  }
                  if (shuLiang > fhShuLiang && RLcount < 1) {
                    RLcount++
                    this.goodsbar.RL = this.getMapValue(ol, 'R/L')
                    //商品条码
                    this.goodsbar.goodsbarcode = this.goodsbar.barcode
                    //仓库编码
                    this.goodsbar.cangkucode = this.controlData.cangkucode
                    //采购单编码
                    this.goodsbar.buyordernum = this.controlData.erpserial
                    ++count;
                    // this.$refs.storegoodsbarcode.focus()
                    this.stockbarcode()
                    break;
                  }

                }
              }
            }
            //商品光度 不存在提示
            if (!compare) {
              this.$alert('商品光度不存在', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$message({
                    type: 'info',
                    message: `请重新扫码!`
                  });
                }
              });
              this.goodsbarcode = ''
              return
            }
            //该商品已达上限提示
            if (count == 0) {
              this.$alert('该' + seedname + packagesize + '已达到上限', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$message({
                    type: 'info',
                    message: `请继续扫码!`
                  });
                }
              });
              this.goodsbarcode = ''
              return
            }
          }
        })
      },
      //库存商品条码扫码出库
      stockbarcode(val) {
        //所有库存商品唯一编码
        this.storebarcode.push(val)
        //更新（ 产品明细）
        if (this.tableData.length > 0) {
          for (let i in this.tableData) {
            var ol = this.tableData[i];
            // this.tableData.map(o1 => {
            var Y = this.getMapValue(ol, '球镜')
            var X = this.getMapValue(ol, '柱镜')
            var seedcode = this.getMapValue(ol, 'seedcode')
            var seedname = this.getMapValue(ol, '产品名称')
            var RL = this.getMapValue(ol, 'R/L')
            var shuLiang = Math.abs(this.getMapValue(ol, '数量'))
            var fh = this.getMapValue(ol, '发货数量');
            if (!fh) fh = 0;
            var fhShuLiang = parseInt(fh)
            var canAdd = false;

            //商品编码 没有光度条码
            if (this.goodsbar.filltemplate == 40) {
              if (seedcode == this.goodsbar.seedcode) {
                //商品编码、光度一样需要一样
                //判断是否已扫描
                if (fhShuLiang > 0) {
                  //判断商品数量大于扫描数量加1,否则继续向下循环
                  if (shuLiang > fhShuLiang) {
                    this.setMapValue(ol, '发货数量', fhShuLiang + 1)
                    canAdd = true;
                  }
                } else {
                  this.setMapValue(ol, '发货数量', 1)
                  canAdd = true;
                }
              }
            } else if (seedcode == this.goodsbar.seedcode && Number(X) == Number(JSON.parse(this.goodsbar.packagesize).X) && Number(Y) == Number(JSON.parse(this.goodsbar.packagesize).Y)) {
              if (this.goodsbar.RL && RL && this.goodsbar.RL != RL) {
                continue
              }
              //商品编码、光度一样需要一样
              //判断是否已扫描
              if (fhShuLiang > 0) {
                //判断商品数量大于扫描数量加1,否则继续向下循环
                if (shuLiang > fhShuLiang) {
                  this.setMapValue(ol, '发货数量', fhShuLiang + 1)
                  canAdd = true;
                }
              } else {
                this.setMapValue(ol, '发货数量', 1)
                canAdd = true;
              }
            }
            if (canAdd) {
              //库存商品唯一编码
              this.goodsbar.storegoodsbarcode = val
              this.goodsbar.status = this.controlData.status
              //将数据添加到采购入库数组中
              this.caiGouRukuData.push(this.goodsbar)
              this.$message({
                message: seedname + '扫码成功',
                type: 'success',
              })
              this.goodsbarcode = ''
              break;
            }
          }
          this.goodsbarcode = ''
        }
      },
      confirmInfor(msg) {
        this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
        }).catch(() => {
        });
        this.onlyonecode = ''
      },
      //查询唯一码
      selectonlyonecode() {
        var val = this.onlyonecode;
        if (!val) return;
        //http://verify.hoya100.com.cn/verify/?sn=1084231284050179&s=-1.50&c=-0.00
        val = val.toString().toLowerCase();
        if (val.indexOf('?') > -1 && val.indexOf('sn=') > -1 && val.indexOf('s=') > -1 && val.indexOf('c=') > -1) {//找眼镜产生的二维码
          var param = val.split('?')[1].split('&');
          var sn = '';
          var x = '';
          var y = '';
          for (let key in param) {
            if (param[key].indexOf('sn=') > -1) {
              sn = param[key].replace('sn=', '');
            } else if (param[key].indexOf('s=') > -1) {
              y = parseFloat(param[key].replace('s=', '')).toFixed(2);
            } else if (param[key].indexOf('c=') > -1) {
              x = parseFloat(param[key].replace('c=', '')).toFixed(2);
            }
          }
          var pagsize = '{"X":"' + x + '","Y":"' + y + '"}';
          this.onlyonecode = '';
          var hasValue = null;
          for (let i in this.form.scancodes) {
            var item = this.form.scancodes[i];
            if (item.storegoodsbarcode) {
              if (item.storegoodsbarcode == sn) {
                this.confirmInfor('重复扫码！');
                return;
              }
              continue;
            }
            if (item.packagesize == pagsize) {
              hasValue = item;
            }
          }
          if (!hasValue) {
            this.confirmInfor('未匹配到光度！');
          } else {
            hasValue.storegoodsbarcode = sn;
            for (let i in this.tableData) {
              var ol = this.tableData[i];
              var seedcode = this.getMapValue(ol, 'seedcode')
              var packagesize = this.getMapValue(ol, 'packagesize')
              var shuliang = this.getMapValue(ol, '数量')
              var fahuoshuliang = this.getMapValue(ol, '发货数量')

              if (hasValue.packagesize == packagesize) {
                if (fahuoshuliang) {
                  //数量必须大于发货数量
                  if (shuliang > fahuoshuliang) {
                    this.setMapValue(ol, '发货数量', fahuoshuliang + 1);
                    break
                  }
                } else {//发货数量没有值时 +1
                  this.setMapValue(ol, '发货数量', 1);
                  break
                }
              }
            }
            this.$message({message: '扫码成功', type: 'success'});
          }
          return;
        }
      },
      isZongBu() {//只有总部人员能操作
        return this.userInfoModel.independentserial == null || this.userInfoModel.independentserial == ""
      },
      //查看处理日志
      handleloglook() {
        this.$refs.HandlelogList.show()
        this.$refs.HandlelogList.initData(this.form.erpserial);
      },
      //处理日志
      handlelog() {
        var handlelog = {}

        handlelog.erpserial = this.form.erpserial
        handlelog.isopen = 1
        handlelog.insub = 1;
        handlelog.totalnumber = Math.abs(this.totalnumber)
        if (this.btn == '填写发货单') {
          handlelog.totalnumber = this.fahuonumber
          handlelog.casestepname = this.buyinfo && this.buyinfo.erpserial ? '以销定采出库' : '库存商品出库';
          handlelog.remark = '已从' + this.form.cangkuname + '发出(物流:' + this.form.logisticsco + ',物流单号:' + this.form.logisticsnum + ')'
        } else if (this.status == '655') {
          handlelog.casestepname = '退货审核通过'
          handlelog.remark = '仓库待收货'
        } else if (this.status == '650') {
          handlelog.casestepname = '退货审核通过'
          handlelog.remark = '等待订单岗确认'
        } else if (this.status == '660') {
          handlelog.casestepname = '退货入库'
          handlelog.remark = '等待财务退款'
        }
        saveData(handlelog).then(response => {
        })
      },
      //加载拣货人候选列表（/set/employee/list offset=0 limit=500）
      loadPickEmployees() {
        if (this.pickEmployees.length > 0)
          return;
        getListData({
          offset: 0,
          limit: 500,
          status: ''
        }).then(response => {
          this.pickEmployees = response.data.obj.rows || []
        }).catch((error) => {
          console.log(error)
        });
      },
      findPickEmployee(uguid) {
        for (let i in this.pickEmployees) {
          if (this.pickEmployees[i].uguid == uguid)
            return this.pickEmployees[i];
        }
        return null;
      },
      //拣货日志：确认出库结束后，为拣货人/拣货审核人各存1条处理日志（用于工作量统计）
      savePickerHandlelog() {
        if (!this.cangkujianhuo || !this.form.pickuser || !this.form.pickaudituser)
          return;
        var picker = this.findPickEmployee(this.form.pickuser);
        var pickAudit = this.findPickEmployee(this.form.pickaudituser);
        var erpserial = this.form.erpserial;
        saveData({
          erpserial: erpserial,
          isopen: 1,
          insub: 1,
          totalnumber: this.fahuonumber,
          casestepname: '拣货人',
          remark: '拣货人：' + (picker ? picker.uname : ''),
          uguid: this.form.pickuser,
          uname: picker ? picker.uname : ''
        });
        saveData({
          erpserial: erpserial,
          isopen: 1,
          insub: 1,
          totalnumber: this.fahuonumber,
          casestepname: '拣货审核人',
          remark: '拣货审核人：' + (pickAudit ? pickAudit.uname : ''),
          uguid: this.form.pickaudituser,
          uname: pickAudit ? pickAudit.uname : ''
        });
      },
      getCangkuNameByCode(cangkucode) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == cangkucode) {
            return this.jxcstoreData[i].cangkuname
          }
        }
      },

      afertupdate(address, linkman, linkmantel) {
        this.controlData.deliveryaddress = address
        this.controlData.linkman = linkman
        this.controlData.linkmantel = linkmantel
      },
      formatTime(nowd) {
        var data = new Date();
        if (nowd) {
          data = new Date(nowd);
        }
        var year = data.getFullYear();
        var month = this.padString2(data.getMonth() + 1);
        var day = this.padString2(data.getDate());
        var hour = this.padString2(data.getHours());
        var minute = this.padString2(data.getMinutes());
        // var second = data.getSeconds();
        return year + '-' + month + '-' + day + " " + hour + ":" + minute;
      },
      padString2(str) {
        if (str < 10) return '0' + str;
        return str;
      },
      getTitle(showname) {
        let result = [];
        if (showname && showname != '') {
          if (showname.indexOf(';') != -1) {
            var obj = showname.split(';')
            for (let i in obj) {
              if (obj[i] && i == 0) {
                result = obj[i]
              } else if (obj[i]) {
                result += ';' + obj[i]
              }
            }
          } else {
            result = showname
          }
        } else {
          let temp = localStorage.getItem("hpapi_userInfoModel")
          if (temp) {
            result += JSON.parse(temp).tenantname || ""
          }
        }
        if (result.indexOf(';') != -1) {
          var obj = result.split(';')
          for (let i in obj) {
            if (obj[i]) {
              if (this.controlData.voucherdetailguid) {
                obj[i] += "铺货单"
              } else {
                obj[i] += "销售订单"
              }
              if (this.isshowyuandd) {
                obj[i] += "(退货单)"
              }
            }
          }
          result = obj.join(';')
        } else {
          if (this.controlData.voucherdetailguid) {
            result += "铺货单"
          } else {
            result += "销售订单"
          }
          if (this.isshowyuandd) {
            result += "(退货单)"
          }
        }
        return result
      },
      changereturntype(val) {
        for (let i in this.tuihuoyy) {
          if (this.tuihuoyy[i].value == val) {
            this.remarktype = this.tuihuoyy[i].name
          }
        }
      },

      showDetail(item) {
        if (!this.flage)
          return;

        var price = {}//商品单价和总价
        let seedcode = ''
        for (let i in item) {
          if (item[i].seedcode) {
            seedcode = item[i].seedcode
          }
          if (item[i]['单价']) {
            price['单价'] = item[i]['单价']
          }
        }
        price['总价'] = this.controlData.htje
        this.$refs.seeddetail.show(price)
        this.$refs.seeddetail.initData(this.unitguid, seedcode, this.form.erpserial)

      },
      createOrderService() {
        this.loadingexpress = true
        var self = this;
        //启用库位号管理且status=350且storenum未赋值时，先创建库位号
        var storenumPromise = Promise.resolve(null);
        if (this.binallocation && this.status == 350 && (!this.storenum || this.storenum == 0)) {
          storenumPromise = getStoreNum({
            customerserial: this.controlData.customerserial || this.form.customerserial,
            deliveryaddress: this.controlData.deliveryaddress
          }).then(response => {
            if (response.data.code == 0 && response.data.obj) {
              self.storenum = response.data.obj;
            }
          });
        }
        storenumPromise.then(function() {
          sfOrderService({
            unitguid: self.unitguid,
            cangkucode: self.form.cangkucode,
            paymethod: self.form.logisticsco,
            remark: (self.binallocation && self.storenum > 0) ? ('库位号:' + self.storenum) : ''
          }).then(response => {
            if (response.data.code == 0) {
              self.form.logisticsnum = response.data.msg;
              if (response.data.express) {
                self.$message({
                  message: '已创建过快递单！',
                  type: 'error'
                })
                self.form.logisticsco = response.data.express
              }

              if (response.data.printurl)
                self.OrderPrintFile(response.data.printurl);
              else {
                self.loadingexpress = false
              }
            } else {
              self.$message({
                message: response.data.msg,
                type: 'error'
              })
              self.loadingexpress = false
            }
          });
        });
      },
      RouteService() {
        sfRouteService({erpserial: this.form.erpserial, expressno: this.form.logisticsnum}).then(response => {
          var newarrr = []
          for (let i in this.supplystatuslist) {
            if (!this.supplystatuslist[i].express) {
              newarrr.push(this.supplystatuslist[i])
            }
          }
          for (let i in response.data.obj) {
            var row = response.data.obj[i]
            newarrr.push({FlagCode: row.status, FlagDateTime: row.time, express: true})
          }
          this.supplystatuslist = newarrr;
          this.supplydrawer = true;
        });
      },
      OrderPrint(needopen) {
        this.loadingexpress = true
        sfOrderPrint({
          erpserial: this.form.erpserial,
          expressno: this.form.logisticsnum,
          cangkucode: this.form.cangkucode
        }).then(response => {
          if (response.data.code == 1) {
            this.$message({message: response.data.msg, type: 'error'});
            this.loadingexpress = false
            return;
          }
          this.OrderPrintFile(response.data.printurl, needopen);
        });
      },
      OrderPrintFile(printurl, needopen) {
        var thisFun = this;
        loadPrintFile(printurl, this.form.cangkucode, function () {
          thisFun.$message({
            message: '已发送到打印机！',
            type: 'success'
          })
          thisFun.loadingexpress = false;
        }, needopen);
        if (needopen) {
          thisFun.loadingexpress = false;
        }
      },
      removeOrderService() {
        this.loadingexpress = true
        this.$confirm("是否确定撤销快递单？", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          sfOrderConfirm({erpserial: this.form.erpserial, expressno: this.form.logisticsnum}).then(response => {
            if (response.data.code == 0) {
              this.form.logisticsnum = '';
              this.$message({
                message: '已成功取消',
                type: 'success'
              })
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
            this.loadingexpress = false
          })
        }).catch(() => {
          this.loadingexpress = false
          this.$message({
            type: 'info',
            duration: 1500,
            message: '已取消'
          });
        });
      },
      shuxiprint() {
        checkprinting({erpserial: this.form.erpserial}).then(response => {
          var printD = response.data.obj.rows;
          this.uname = printD[0].uname;
          this.adddate = printD[0].adddate;
          this.tips()
        })
      },
      loadframeexcel() {//镜架明细导出成EXCEL
        exportExcelV2({
          customername: this.controlData.customername,
          erpserial: this.controlData.erpserial,
          businessType: 'saleerorderframe'
        }, this.controlData.erpserial + ' ' + this.controlData.customername + '.xls')
      },
      printBox() {
        this.$refs.Boxsticker1.print(this.goodsDetail);
      },
      handlePrintLabel(command) {
        this.printLabelLoading = true;
        //单片模式：command 以 P 结尾（backP/preP/packageP），实际标签类型去掉 P
        const isSingle = typeof command === 'string' && command.length > 1 && command.charAt(command.length - 1) === 'P';
        const labelType = isSingle ? command.substring(0, command.length - 1) : command;
        getPrintLabelData({
          erpserial: this.form.erpserial,
          labelType: labelType
        }).then(response => {
          this.printLabelLoading = false;
          const data = response.data.obj;
          if (!data || data.length === 0) {
            this.$message.warning('没有可打印的标签数据');
            return;
          }
          if (isSingle) {
            //单片：拉全量后弹出选择页（球镜/柱镜筛选）
            this.$refs.lensLabelPrint.printSingle(data, labelType);
          } else {
            this.$refs.lensLabelPrint.print(data, command);
          }
        }).catch(() => {
          this.printLabelLoading = false;
          this.$message.error('获取打印数据失败');
        });
      },
      printOutStock() {
        this.isPrintOutStock = true;
        this.printday = '（' + this.formatTime() + '打单）';
        this.showtitle1 = "";
        this.isprint = true;
        var self = this;
        this.$nextTick(() => {
          self.$print(self.$refs.print1);
          self.showtitle1 = "none";
          self.isprint = false;
          self.isPrintOutStock = false;
        });
      },
      // 拣货单打印（成品订单status=350）
      pickupPrint() {
        this.$refs.pickupprint.show(this.controlData, this.controlData.goodsdetail, this.userInfoModel)
      },
      printPre(showprice) {
        this.noprintbutton = showprice == 2 || showprice == 4;
        this.printhuiz = showprice == 3 || showprice == 4;
        this.print1(false, showprice);
      },
      //打印
      print1(printBaiBao, printtype) {
        this.printBaiBao = printBaiBao;
        checkprinting({erpserial: this.form.erpserial, printtype: printtype}).then(response => {
          var printD = response.data.obj.rows;
          if (printD.length > 0) {//表示打印过，需要做出提醒
            this.$confirm('该订单“' + printD[0].uname + '”已于' + printD[0].adddate + '打印过，是否继续?', '提示', {
              confirmButtonText: '取消',
              cancelButtonText: '继续打印',
              type: 'error'
            }).then(() => {
              this.printBaiBao = false;
              this.printhuiz = false;
            }).catch(() => {
              if (this.pagetitle.indexOf(";") != -1) {
                if (this.userInfoModel.independentserial)
                  this.isNoshow = true
                this.$refs.Printtitle.show(this.pagetitle, false)
              } else {
                this.startprint(false, printtype);
              }
            });
          } else {
            if (this.pagetitle.indexOf(";") != -1) {
              if (this.userInfoModel.independentserial)
                this.isNoshow = true
              this.$refs.Printtitle.show(this.pagetitle, true, printtype)
            } else {
              this.startprint(true, printtype);
            }
          }
        });

      },
      printtitlename(pagetitle, needreflash, printtype) {
        this.pagetitle = pagetitle
        this.startprint(needreflash, printtype)
      },
      startprint(needreflash, printtype) {
        var storenumPromise = Promise.resolve(null);
        var self = this;
        //页面加载时已获取到库位号则直接使用，否则再取（status=350可创建）
        if (this.binallocation&&self.status == 350 && (!this.storenum || this.storenum == 0)) {
          storenumPromise = getStoreNum({
            customerserial: this.controlData.customerserial || this.form.customerserial,
            deliveryaddress: this.controlData.deliveryaddress
          }).then(response => {
            if (response.data.code == 0 && response.data.obj) {
              self.storenum = response.data.obj;
              return self.storenum;
            }
            return null;
          });
        }
        storenumPromise.then(() => {
          self.printday = '（' + self.formatTime() + '打单）';
          self.showtitle1 = ""
          self.isprint = true
          var printD = self.printDisplay;
          if (self.noprintbutton) {//点击的是不打印按钮的价格
            self.printDisplay = false;
          }
          self.$nextTick(() => {
            self.$print(self.$refs.print1)
            self.showtitle1 = "none"
            self.isprint = false
            self.printBaiBao = false
            self.printDisplay = printD;
            self.printhuiz = false
            self.isPrintOutStock = false

            save({
              erpserial: self.form.erpserial,
              invoicesource: self.form.invoicesource,
              printtype: printtype,
              deliveryaddress: self.controlData.deliveryaddress,
              customerserial: self.controlData.customerserial || self.form.customerserial,
              //已生成过库位号的订单（含前几天已发货今天补打印）不再写入storenum，
              //避免历史大号以今天的AddDate写入printlog污染当天max库位号
              storenum: self.hasStoreNum ? 0 : self.storenum
            }).then(response => {
              if (response.data.code == 0) {
                if (needreflash) {
                  self.$emit("bindGrid");//未打印过，刷新父页面
                }
                self.shuxiprint()
                self.$message({
                  message: '生成打印日志',
                  type: 'success'
                })
              }
            })
          })
        })
      },
      tips() {
        if (this.uname) {
          var d = new Date(this.adddate);
          return "打印：" + this.uname + " " + (d.getMonth() + 1) + "-" + d.getDate() + " " + d.getHours() + ":" + d.getMinutes() + ""
        } else {
          return "未打印过"
        }
      },
      //查看加工单
      lookMachineOrder(row) {
        this.$parent.$refs.machiningedit.initData(row);
        this.$parent.$refs.machiningedit.show();
      },
      addMachineOrder() {//补加工单
        if (this.controlData.status == 200 || this.checkdeliver()) {
          this.$refs.JxcgooddetailSel1.setFilltemplate('50');
          this.$refs.JxcgooddetailSel1.showBind();
        }
      },
      afterSelectMachinecode(row) {//选择加工商品后
        this.selectedMachineRow = row;
        this.machiningQty = 1;
        this.machiningQtyDialogVisible = true;
        this.$nextTick(() => {
          if (this.$refs.machiningQtyInput) {
            const input = this.$refs.machiningQtyInput.$el.querySelector('input');
            if (input) {
              input.focus();
              input.select();
            }
          }
        });
      },
      handleMachiningQtyFocus(event) {
        event.target.select();
      },
      confirmMachiningQty() {
        this.machiningQtyDialogVisible = false;
        var row = this.selectedMachineRow;
        if (!row) return;
        var params = {
          erpserial: this.controlData.erpserial,
          seedcode: row.seedcode,
          number: this.machiningQty
        };
        // 当原单状态为200(待确认)时，补的加工单状态为300(待加工)，不需要快递号
        if (this.controlData.status == 200) {
          params.status = 300;
        } else {
          params.logisticsco = this.form.logisticsco;
          params.logisticsnum = this.form.logisticsnum;
        }
        addMachineOrder(params).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: response.data.msg,
              type: 'success'
            })
            this.aftermachineadd = true;
            this.pageinit.row.logisticsco = this.form.logisticsco;
            this.pageinit.row.logisticsnum = this.form.logisticsnum;
            this.reflashInit();
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      },
      //保存退货订单选项
      saveReturnOrder() {
        let jxcformdetails = [];
        for (let i in this.tableData) {
          let jxcformdetail = {
            unitguid: '',
            brokenparts: ''
          };
          let checked = true
          for (let j in this.tableData[i]) {

            if (this.tableData[i][j]["unitguid"]) {
              jxcformdetail.unitguid = this.tableData[i][j]["unitguid"]
            }
            // if (this.tableData[i][j]["是否坏件"]) {
            //   checked = this.tableData[i][j]["是否坏件"].ischecked
            // }
          }
          if (checked) {
            jxcformdetail.brokenparts = -1
          } else {
            jxcformdetail.brokenparts = 1
          }
          jxcformdetails.push(jxcformdetail)
        }
        if (this.form.orderopinion == '' && this.status == 655 && this.controlData.sycstagreementDO.status == '待发货') {
          this.$message({
            message: '请选择工厂回复意见',
            type: 'error'
          })
          this.loading = false;
          return
        }
        this.loading = true;
        returnGoodsUpdate({
          formdetails: JSON.stringify(jxcformdetails),
          cstagreementDO: JSON.stringify({
            returntype: this.controlData.returntype,
            cangkutuihuoremark: this.cangkutuihuoremark,
            remark: this.remark,
            remarktype: this.remarktype,
            orderopinion: this.form.orderopinion,
            hetongserial: this.controlData.sycstagreementDO.erpserial,
          })
        }).then(response => {
          this.loading = false;
          if (response.data.code == 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            if (this.status == 660) {
              this.saveBarCodeData();
            }
            this.handlelog();
            this.dialogSeeVisible = false
            //刷新列表
            this.$emit("bindGrid")
          } else {
            this.$message({
              message: '保存失败',
              type: 'error'
            })
          }
        })
      },
      show(isShowAdressAndCangkuUpdate) {
        if (isShowAdressAndCangkuUpdate == 1) {
          this.isShowAdressAndCangkuUpdate = false
        } else {
          this.isShowAdressAndCangkuUpdate = true
        }
        this.dialogSeeVisible = true;
      },
      showprint() {
        this.dialogSeeVisible = true;
        this.isprint = true;
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      lookDetails(row) {
        if (row && row.erpserial&&row.erpserial!='无')
          this.$parent.lookDetails(row)
      },
      updatecangku(row) {
        row.buyunitguid = '';
        if (this.buyinfo && this.buyinfo.unitguid) {
          row.buyunitguid = this.buyinfo.unitguid;
        }
        this.$refs.StoreEdit.initData(row, -1, 'mini-dialog', 1);
      },
      afertupdatecangku(cangkucode, cangkuname, warehouse, warehousename) {
        this.controlData.cangkucode = cangkucode
        this.form.cangkucode = cangkucode
        this.controlData.cangkuname = cangkuname

        this.controlData.warehouse = warehouse
        this.controlData.warehousename = warehousename
      },
      updateaddress() {
        this.$refs.UpdateAddress.show(this.controlData)
      },
      getLiuYan(remark) {
        if (this.isprint) {
          var html = getKHRemark(remark);
          // 打印时不显示人员和时间（中文括号包裹的内容）
          return html.replace(/（[^）]*?）/g, '');
        }
        return getRemark(remark);
      },
      //岗位类型
      yincangdayin(roletype) {
        this.roletype = roletype
      },
      reflashInit() {
        this.initData(this.pageinit.row, this.pageinit.btn, this.pageinit.groupguid, this.pageinit.seedcode)
      },
      initData(row, btn, groupguid, seedcode) {
        this.pageinit.row = row
        this.pageinit.btn = btn
        this.pageinit.groupguid = groupguid
        this.pageinit.seedcode = seedcode
        this.initForm()
        this.flage = false;
        this.isFrame = false;
        //重置扫码相关状态，避免其他订单打开时残留
        this.hasScancodeData = false;
        this.scanCodeList = [];
        this.scancodeViewVisible = false;

        for (let i in row.jxcformdetailDOList) {
          var ft = row.jxcformdetailDOList[i].filltemplate;
          if (ft == "80") {
            this.isFrame = true;
          }
          if (ft == "10" || ft == "20" || ft == "30" || ft == "80") {
            this.flage = true;
            break;
          }
        }

        this.status = row.status
        this.btn = btn
        this.form.erpserial = row.erpserial
        this.imgpath = window.API_ROOT + "/api/avatar/getBarcode?content=" + row.erpserial

        if (row.customername) {
          this.form.customername = row.customername
        }
        if (row.logisticsco) {
          this.form.logisticsco = row.logisticsco
        }

        if (row.logisticsnum) {
          this.form.logisticsnum = row.logisticsnum
        }
        if (row.cangkucode) {
          this.form.cangkucode = row.cangkucode
        }
        this.groupguid = groupguid
        this.unitguid = row.unitguid
        this.storescan = this.storescanSys;
        printing({
          unitguid: row.unitguid,
          erpserial: this.form.erpserial,
          groupguid: this.groupguid,
          seedcode: seedcode
        }).then(response => {
          this.buyinfo = response.data.obj.caigoudan;

          if (response.data.obj.supplytaskid) {
            this.supplytaskid = response.data.obj.supplytaskid;
            if (response.data.obj.supplystatuslist) {
              this.supplystatuslist = response.data.obj.supplystatuslist;
            }
          }
          //系统对接扫码
          if (this.btn == '填写发货单' && response.data.obj.supplytaskid) {
            this.storescan = true;
          }

          //打印日志
          if (response.data.obj.printlogDOList.length > 0) {
            this.printData = response.data.obj.printlogDOList
            this.uname = this.printData[0].uname
            this.adddate = this.printData[0].adddate
          }

          //启用库位分配时，使用getStoreNum从后台获取库位号
          //status=350根据当天日期，status=400/500根据办结日期(handleoverdate)
          if (this.binallocation) {
            var adddate = '';
            if (this.status == 350) {
              adddate = this.formatTime().substring(0, 10);
            } else if (this.status == 400 || this.status == 500) {
              adddate = row.handleoverdate ? row.handleoverdate.substring(0, 10) : '';
            }
            var self = this;
            getStoreNum({
              customerserial: row.customerserial || this.form.customerserial,
              deliveryaddress: row.deliveryaddress,
              adddate: adddate,
              queryonly: true
            }).then(function(response) {
              if (response.data.code == 0 && response.data.obj) {
                self.storenum = response.data.obj;
                self.hasStoreNum = true;//该订单已生成过库位号
              }
            });
          }

          this.controlData = response.data.obj.detail;
          this.controlData.goodsdetail = response.data.obj.goodsDetail;
          //提前赋值标题与商品明细：即使后续字段处理异常，表单标题和数据也已渲染，避免打开即空白
          this.isshowyuandd = this.controlData.isreturnorder && this.controlData.isreturnorder == 1;
          if (this.isshowyuandd && !this.controlData.sycstagreementDO.erpserial) {
            this.controlData.sycstagreementDO.erpserial = '无'
          }
          this.goodsDetail = response.data.obj.goodsDetail;
          this.tableData = response.data.obj.goodsDetail;
          this.pagetitle = this.getTitle(response.data.obj.detail.printdname);
          if (this.imgLogURLSet) {
            if (this.controlData.currency == null) this.controlData.currency = '';
            if (this.imgLogURLSet['imglogurl' + this.controlData.currency]) {
              this.imgLogURL = this.imgLogURLSet['imglogurl' + this.controlData.currency];
            } else if (this.imgLogURLSet['imglogurl']) {
              this.imgLogURL = this.imgLogURLSet['imglogurl'];
            }
          }

          //填写发货单时：查询该订单是否已有扫码记录（只取合计数字判断，有则只读展示，禁改发货数量，只能确认出库）
          if (this.btn == '填写发货单' && this.form.erpserial) {
            listByInordernum({inordernum: this.form.erpserial, count: true}).then(resScan => {
              if (resScan.data.code == 0 && resScan.data.obj > 0) {
                this.hasScancodeData = true;
              }
            });
          }

          //查询当前订单是否有配送券
          ispsq({customerserial: response.data.obj.detail.customerserial}).then(resPSQ => {

            if (resPSQ.data.obj <= 0) {
              for (let i in this.parameterData) {
                if (this.parameterData[i].name == '配送') {
                  this.parameterData.splice(i, 1)
                }
              }
            }
            //deliverymode
            //确认发货：当天同一个门店的订单公用一个物流号以及物流方式
            if (this.controlData.length != 0 && !this.aftermachineadd) {
              if (this.controlData.logisticsco) {
                this.form.logisticsco = this.controlData.logisticsco
              } else {
                var logItem = '';
                if (this.controlData.deliverymode) {
                  for (let i in this.parameterData) {
                    if (this.parameterData[i].name == this.controlData.deliverymode) {
                      logItem = this.parameterData[i].name;
                      break;
                    }
                  }
                }
                if (logItem) {
                  this.form.logisticsco = logItem;
                } else {
                  this.form.logisticsco = this.parameterData.length > 1 ? this.parameterData[1].name : (this.parameterData.length > 0 ? this.parameterData[0].name : '')
                  if (this.form.logisticsco == '顺丰到付') this.form.logisticsco = this.parameterData[0].name;
                }
              }
              if (btn == '邮寄' && this.form.logisticsco == '待邮寄') {
                this.form.logisticsco = this.parameterData.length > 0 ? this.parameterData[0].name : '';
              }
              if (this.controlData.logisticsnum) {
                this.form.logisticsnum = this.controlData.logisticsnum
              }
              if(btn=='填写发货单'&&!this.form.logisticsnum){
                for (let i in this.parameterData) {
                  if (this.parameterData[i].name == '待邮寄') {
                    this.controlData.logisticsnum='';
                    this.form.logisticsnum='';
                    this.controlData.logisticsco='待邮寄';
                    this.form.logisticsco='待邮寄';
                    break;
                  }
                }
              }
            }

            //只有总部人员、订单的applybydserial!=''、订单的independentserial==''、订单的deliverymode=配送或自取或内部调拨
            //才可以出现下拉框
            if ((this.isZongBu() && this.controlData.independentserial == null && this.controlData.applybydserial != null &&
              this.controlData.independentserial == "" && this.controlData.applybydserial != "") &&
              (row.deliverymode == '配送' || row.deliverymode == '自取' || row.deliverymode == '内部调拨') && this.controlData.htje >= 0 && this.controlData.formtype == 42) {
              this.form.eliverydStatus = '400'
            }
          })


          this.aftermachineadd = false;//补加工单后 物流不要重新赋值
          //加工单条形码
          if (this.controlData.machinecstagreementDO)
            this.jiagongimgpath = window.API_ROOT + "/api/avatar/getBarcode?content=" + this.controlData.machinecstagreementDO.erpserial
          this.form.logisticstracknum = this.controlData.logisticstracknum
          this.form.tracknum = this.controlData.tracknum

          // if (this.controlData.yfk == 0) {
          //   this.controlData.sycstagreementDO.paymethod = '按合同结算'
          // }
          if (this.controlData.returntype) {
            let remark = JSON.parse(this.controlData.remark.replace(new RegExp("\n", "gm"), ""))
            if (this.tuihuoyy) {
              for (let i in this.tuihuoyy) {
                if (this.tuihuoyy[i].value == this.controlData.returntype) {
                  this.remarktype = this.tuihuoyy[i].name
                }
              }
            }

            for (let i in remark) {
              if (remark[i].type == '退货原因')
                this.remark = remark[i].msg
            }
            this.controlData.returntype = this.controlData.returntype + ''
          } else if (this.tuihuoyy && this.tuihuoyy.length > 0) {
            this.controlData.returntype = this.tuihuoyy[0].value
            this.remarktype = this.tuihuoyy[0].name
          }
          if (this.controlData.sycstagreementDO.unitguid) {
            if (this.controlData.sycstagreementDO.status == "200") {
              this.controlData.sycstagreementDO.status = "待确认"
            } else if (this.controlData.sycstagreementDO.status == "350") {
              this.controlData.sycstagreementDO.status = "待发货"
            } else if (this.controlData.sycstagreementDO.status == "400") {
              this.controlData.sycstagreementDO.status = "待配送"
            } else if (this.controlData.sycstagreementDO.status == "500") {
              this.controlData.sycstagreementDO.status = "已发货"
            }
          }

          this.form.invoicesource = response.data.obj.detail.invoicesource;
          this.printDisplay = (this.controlData.isshowprice && this.controlData.isshowprice.indexOf('4') != -1);//打印订单价格
          if (this.daiGuansend) {
            this.printDisplay = false;
          }
          if (this.userInfoModel.tenantid == 'd6d0f500-6c34-45e6-b206-b87c368e4469')
            this.showDisplayPrice(this.controlData);

          //仓库发货扫唯一码
          this.form.scancodes = response.data.obj.scancodes;
          if (this.form.scancodes && this.form.scancodes.length > 0) {
            this.$nextTick(() => {
              if (this.$refs.onlyonecodeRef)
                this.$refs.onlyonecodeRef.focus();
            });
          }
          if (this.tableData.length > 0) {
            //取出表头
            let temparr = []
            let biaoji = 0

            //计算商品的小计
            this.seedsub = [];
            var hasYanj = false;
            for (let i in this.tableData) {
              var items = this.tableData[i];
              this.totalnumber += (items["数量"] || 0);
              this.totalmoney += (items["总价"] || 0.00);

              if (items["subseedcode"])
                this.changeBaibao = true;

              var hasCheckIn = false;
              for (let j in this.seedsub) {
                if (this.seedsub[j].seedcode == items.seedcode) {
                  hasCheckIn = true;
                  this.seedsub[j].index = i;
                  this.seedsub[j].num += 1;
                  this.seedsub[j]["数量"] += (items["数量"] || 0);
                  this.seedsub[j]["总价"] += parseFloat(items["总价"] || 0.00);
                  break;
                }
              }
              if (!hasCheckIn) {
                this.seedsub.push({
                  seedcode: items.seedcode,
                  '数量': (items["数量"] || 0),
                  '总价': (items["总价"] || 0.00),
                  num: 1,
                  index: i
                })
              }

              if (this.flage && !this.isFrame && this.seedsub.length > 1) {
                for (let j in this.seedsub) {
                  if (this.seedsub[j].num > 1)
                    this.showxiaoji = true;
                }
              }

              for (let j in items) {
                if (j == "R/L") {
                  biaoji = 1
                }
                if (j != "seedcode" && j != "R/L" && j != "数量" && j != "说明" && j != "产品名称" && j != "球镜" && j != "柱镜" && j != "是否坏件" && j != "轴位" && j != "unitguid" && !this.contains(j, temparr) && j != "单价" && j != "总价" && j.indexOf('优化') == -1) {
                  temparr.push(j)
                } else {
                  if (j == "球镜")
                    hasYanj = true
                }
              }
            }
            this.subtotalmoney = parseFloat(this.totalmoney) + parseFloat(this.controlData.expressfee);
            if (this.controlData.machinecstagreementDO && this.controlData.machinecstagreementDO.unitguid) {
              var mach = this.controlData.machinecstagreementDO;
              this.subtotalmoney += parseFloat(this.controlData.machinecstagreementDO.htje) - parseFloat(mach.discount ? mach.discount : 0);
            }

            //对表头排序
            this.column.push("unitguid")
            this.column.push("seedcode")
            if (biaoji == 1) {
              this.column.push("R/L")
            }
            this.column.push("产品名称")
            if (hasYanj) {
              this.column.push("球镜")
              this.column.push("柱镜")
              this.column.push("轴位")
              this.hasFrame = false;
            }
            this.column = this.column.concat(temparr)
            this.column.push("数量")
            if (this.btn == '填写发货单') {//增加需要发货数量
              this.column.push("发货数量")
            }
            // else if (this.btn && this.btn == 1) {
            //   this.column.push("扫码确认")
            // }
            if (this.btn && this.btn == 1) {
              this.isreturnorderEidt = true
              getBackpercent({erpserial: this.controlData.erpserial}).then(resBack => {
                if (resBack.data && resBack.data.backpercent) {
                  this.returnorderpercent = resBack.data.backpercent;
                }
              });
              this.column.push("是否坏件")
            } else {
              this.isreturnorderEidt = false
            }
            this.column.push("单价")
            this.column.push("总价")

            //this.column.push("说明")

            this.tableData = this.tableData.map(o1 => this.column.map(o2 => {
              let ob = {}
              if (o2 == '发货数量') {
                if (this.storescan || this.form.scancodes.length > 0) {
                  ob[o2] = ''
                } else {
                  ob[o2] = o1["数量"] || 0
                }
              } else
                ob[o2] = o1[o2] || ""
              return ob
            }))
          }
          this.parameter = response.data.obj.parameter

          this.batchbarcode = response.data.obj.batchbarcode;
          if (response.data.obj.batchbarcode && response.data.obj.batchbarcode.length > 0 && response.data.obj.batchbarcode[0].batchno) {
            this.scancodeloadBatch(response.data.obj.batchbarcode);
          }

          //信用额度
          this.linecredit = '';
          this.ticket = response.data.obj.ticket;
          // 逾期控制：填写发货单时，若客户被设置为不允许开单/不允许发货，则锁定表单并在顶部提示
          var overduecontrolmsg = response.data.obj.overduecontrolmsg;
          if (this.btn == '填写发货单' && overduecontrolmsg) {
            this.$message({ message: overduecontrolmsg, type: 'warning', duration: 5000 });
            this.loading = true;
            this.ticket = this.ticket ? (this.ticket + ';' + overduecontrolmsg) : overduecontrolmsg;
          }
          if (response.data.obj.linecredit && this.controlData.paymethod.indexOf('按合同结算') > -1) {
            getDuiZhangCus({customerserial: this.controlData.customerserial}).then(resCredit => {
              if (resCredit.data.code == 0) {
                var useMoney = parseFloat(resCredit.data.obj) + parseFloat(this.controlData.htje | 0) + parseFloat(this.controlData.expressfee | 0);//已使用金额
                this.linecredit = (parseFloat(response.data.obj.linecredit) - useMoney).toFixed(2);
                if (useMoney > parseFloat(response.data.obj.linecredit) && !(resCredit.data.settingmoney == 99)) {//超额 不给发货
                  this.loading = true;
                }
              }
            })
          }

          //退货单
          this.tuihuoorders = response.data.obj.tuihuoorders
          if (this.tuihuoorders.length > 0) {
            this.isycjorder = true
            if (this.tuihuoorders.length > 0) {
              for (let g = 0; g < this.tuihuoorders.length; g++) {
                //取出表头
                let temparr = []
                let biaoji = 0
                this.tuihuocolumn = []
                for (let i in this.tuihuoorders[g]['billmap']) {
                  for (let j in this.tuihuoorders[g]['billmap'][i]) {
                    if (j == "R/L") {
                      biaoji = 1
                    }
                    if (j != "seedcode" && j != "R/L" && j != "数量" && j != "说明" && j != "产品名称" && j != "球镜" && j != "柱镜" && j != "轴位" && !this.contains(j, temparr) && j != "销售单号" && j != "本次采购数量" && j != "unitguid" && j != "单价" && j != "总价") {
                      temparr.push(j)
                    }
                  }
                }
                //对表头排序
                this.tuihuocolumn.push("seedcode")
                if (biaoji == 1) {
                  this.tuihuocolumn.push("R/L")
                }
                this.tuihuocolumn.push("产品名称")
                if (hasYanj) {
                  this.tuihuocolumn.push("球镜")
                  this.tuihuocolumn.push("柱镜")
                  this.tuihuocolumn.push("轴位")
                }
                this.tuihuocolumn = this.tuihuocolumn.concat(temparr)
                this.tuihuocolumn.push("数量")
                this.tuihuocolumn.push("单价")
                this.tuihuocolumn.push("总价")

                this.tuihuoorders[g]['tuihuocolumn'] = this.tuihuocolumn
                this.tuihuoorders[g]['billmap'] = this.tuihuoorders[g]['billmap'].map(o1 => this.tuihuocolumn.map(o2 => {
                  let ob = {}
                  ob[o2] = o1[o2]
                  return ob
                }))
              }
            }
          }
        }).catch(err => {
          console.error('打印单数据加载失败', err);
          this.loading = false;
          this.$message({message: '数据加载失败，请重试', type: 'error'})
        });
      },
      printloglook() {
        this.$refs.printlogList.show()
        this.$refs.printlogList.initData(this.form.erpserial);
      },
      //封装表头
      tablesoret(temparr, biaoji, column, table) {

      },
      showError(errorinfo) {
        this.$message({
          message: errorinfo,
          type: 'error'
        })
      },
      checkdeliver() {
        if (!(this.form.logisticsco.indexOf('自取') > -1 || this.form.logisticsco.indexOf('配送') > -1 || this.form.logisticsco.indexOf('邮寄') > -1) && !this.form.logisticsnum) {
          this.showError('请填写快递单号！')
          this.loading = false;
          return false;
        }
        return true;
      },
      delivergoodsFast() {
        for (let g = 0; g < this.tableData.length; g++) {
          var arr = this.tableData[g];
          var shuliang = parseInt(this.getMapValue(arr, '数量'));
          this.setMapValue(arr, '发货数量', shuliang);
        }
        this.supplytaskid = '';
      },
      erchidelivergoods() {
        if (this.form.logisticsco != '配送' && this.form.logisticsco != '自取') {
          if (!this.form.logisticsnum) {
            this.$message({message: '请输入物流单号', type: 'error', duration: 1500})
            return
          }
        }
        ercifahuo({unitguid:this.controlData.unitguid,logisticsnum:this.form.logisticsnum.trim(),logisticsco:this.form.logisticsco}).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '保存成功！',
              type: 'success'
            })
            this.$emit('bindGrid');
            this.dialogSeeVisible = false;
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      },
      delivergoods() {
        let orderTotalNum = 0;
        let fahuoTotalNum = 0;
        let jxcformdetails = [];
        let res = /^[+]{0,1}(\d+)$/;
        if(this.supodderrequired&&this.btn=='填写发货单'&&!this.form.tracknum&&this.buyinfo&&this.buyinfo.erpserial) {
          this.showError('供应商单号 GY.NO 必填填写！')
          this.loading = false;
          return
        }
        for (let i in this.tableData) {
          let jxcformdetail = {
            unitguid: '',
            fahuonumber: ''
          };
          let number = 0;
          for (let j in this.tableData[i]) {
            if (this.tableData[i][j]["unitguid"]) {
              jxcformdetail.unitguid = this.tableData[i][j]["unitguid"]
            }
            if (this.tableData[i][j]["发货数量"]) {
              jxcformdetail.fahuonumber = this.tableData[i][j]["发货数量"]
            }
            if (this.tableData[i][j]["数量"]) {
              number = this.tableData[i][j]["数量"]
            }
          }
          if (!res.test(jxcformdetail.fahuonumber || 0)) {
            this.showError('请填写正确的发货数量')
            this.loading = false;
            return
          }
          if (jxcformdetail.fahuonumber > number) {
            this.showError('第'+(parseInt(i)+1)+'行发货数量不能大于订单数量')
            this.loading = false;
            return
          }
          if (jxcformdetail.fahuonumber > 0) {
            jxcformdetails.push(jxcformdetail)
            fahuoTotalNum += parseInt(jxcformdetail.fahuonumber);
          }
          orderTotalNum += parseInt(number);
        }
        if (jxcformdetails.length <= 0) {
          this.showError('请输入发货数量')
          this.loading = false;
          return
        }
        if(!this.checkdeliver()) {
          return;
        }
        //拣货管理：商品数量>=10时必须选择拣货人和拣货审核人
        if (this.cangkujianhuo && this.btn=='填写发货单' && parseInt(this.totalnumber) >= 10) {
          if (!this.form.pickuser) {
            this.showError('商品数量大于等于10，请选择拣货人')
            this.loading = false;
            return
          }
          if (!this.form.pickaudituser) {
            this.showError('商品数量大于等于10，请选择拣货审核人')
            this.loading = false;
            return
          }
        }

        this.form.jxcformdetaillist = JSON.stringify(jxcformdetails)
        if (orderTotalNum > fahuoTotalNum) {
          if(this.controlData.isfile&&this.controlData.isfile==9){
            this.showError('发货数量不正确，直发订单不允许拆单发！')
            this.loading = false;
            return
          }
          this.$confirm('填写的发货数量：' + fahuoTotalNum + ' ，小于订单数量：' + orderTotalNum + '，是否拆单发货？', '提示', {
            confirmButtonText: '确定拆单',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.afterDeliverGoods();
          }).catch(() => {
            this.loading = false;
          });
        } else {
          this.afterDeliverGoods();
        }
      },
      afterDeliverGoods() {
        // for (let i = 0; i < this.jxcstoreData.length; i++) {
        //   if (this.jxcstoreData[i].cangkucode == this.form.cangkucode) {
        //     this.form.cangkuname = this.jxcstoreData[i].cangkuname
        //     break
        //   }
        // }
        this.form.cangkuname = this.controlData.cangkuname;
        this.form.cangkucode = this.controlData.cangkucode;
        // if (this.controlData.isdistribute != 'undefined') {
        //   this.form.isdistribute = this.controlData.isdistribute
        // }
        this.form.formtype = 72
        if (this.form.logisticstracknum)
          this.form.logisticstracknum = this.form.logisticstracknum.trim();
        if (this.form.tracknum)
          this.form.tracknum = this.form.tracknum.trim();
        this.loading = true;
        this.form.resontxt = JSON.stringify(this.form.scancodes)
        this.form.scancodes = []
        multipleShipments(this.form).then(response => {
          this.loading = false;
          if (response.data.code == 0) {

            // 如果有关联加工单且加工单状态为350(已加工)，自动更新为500(已出库)
            if (this.controlData.machinecstagreementDO && this.controlData.machinecstagreementDO.status == 350) {
              deliveryOver({
                erpserial: this.controlData.machinecstagreementDO.erpserial,
                logisticsco: this.form.logisticsco,
                logisticsnum: this.form.logisticsnum
              }).then(responseM => {
                this.$emit("cutItemAfterHandle", this.controlData.machinecstagreementDO.erpserial)
              });
            }

            if (this.$refs.ScanCodeSupplyer) {
              this.$refs.ScanCodeSupplyer.saveQRCode();//触发物流码出库
            }

            if (response.data.neworder) {
              if (this.printoutstock) {
                // 缺货单模式：弹出拆单发货对话框
                var newRow = JSON.parse(JSON.stringify(response.data.neworder))
                var originalRow = JSON.parse(JSON.stringify(this.pageinit.row))
                this.$refs.splitOrderPrint.show(newRow, originalRow)
                this.handlelog()
                this.savePickerHandlelog()
                this.$emit('bindGrid');
                // this.$emit('cutItemAfterHandle', this.form.erpserial)
                this.dialogSeeVisible = false
              } else {
                this.form.erpserial = response.data.neworder.erpserial
                this.$message({
                  message: '操作成功，新的单号：' + this.form.erpserial,
                  type: 'success'
                })
                this.handlelog();
                this.savePickerHandlelog();
                this.initData(response.data.neworder)
              }
            } else {
              this.$message({
                message: response.data.msg,
                type: 'success'
              })
              this.handlelog();
              this.savePickerHandlelog();
              // this.saveBarCodeData();//保存商品码和库存码 到数据库
              this.$emit("cutItemAfterHandle", this.form.erpserial)
              this.dialogSeeVisible = false
            }
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        });
      },
      orderClose(){
        this.$emit("orderClose");
      },
      //保存仓库货品条形码关系表
      saveBarCodeData() {
        batchSave({caiGouRukuData: JSON.stringify(this.caiGouRukuData)}
        ).then(response => {
        })
      },
      showDisplayPrice(row) {
        // if (this.userInfoModel.myright.indexOf('财务') != -1 || this.userInfoModel.myright.indexOf('查看订单价格') != -1) {
        //   this.showlookprice = true;
        // } else {
          this.showlookprice = false;
        // }
        if (row) {
          if (this.userInfoModel.independentserial && this.userInfoModel.independentserial != row.applybydserial) {
            this.showlookprice = false;
            this.printDisplay = false;
          }
        }
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.loading=false
        this.loadingexpress=false;
        this.changeBaibao=false;
        this.hasFrame=true;
        this.linecredit=''
        this.ticket=''
        this.supplytaskid = ''
        this.returnorderpercent='';
        this.showscantable = true
        this.handlelogData = []
        this.printBaiBao=false
        this.drawer = ''
        this.storenum=0;
        this.hasStoreNum=false;
        this.form.storegoodsbarcode = ''
        this.groupguid = ""
        this.column = []
        this.showxiaoji = false
        this.tableData = []
        this.unitguid = ""
        this.totalmoney = 0
        this.totalnumber = 0
        this.isycjorder = false
        this.supplystatuslist=[]
        this.form.logisticsnum = ''
        this.form.logisticsco = ''
        this.form.isdistribute = ""
        this.form.cangkucode = ""
        this.form.cangkuname = ""
        this.form.erpserial = ""
        this.form.deliverymode = 10
        this.form.customername = ''
        this.form.customerserial = ''
        this.form.independentserial = ''
        this.form.origionstatus = ''
        this.form.jxcformDetailDo = ''
        this.form.formtype = ''
        this.form.orderopinion = ''
        this.form.eliverydStatus = ''
        this.uname = ''
        this.adddate = ''
        this.flage = true
        this.goodsbarcode = ''
        this.form.logisticstracknum = ''
        this.form.tracknum=''
        this.form.pickuser = ''
        this.form.pickaudituser = ''
        this.printDisplay = false
        this.remark = ""
        this.remarkselection = ""
        this.cangkutuihuoremark = ""
        this.form.scancodes = []
      }
    },
    computed: {
      fahuonumber() {
        let s = 0
        this.tableData.forEach(o => {
          o.forEach(o2 => {
            if (typeof o2["发货数量"] != 'undefined') {
              s += parseInt(o2["发货数量"] || 0)
            }
          })
        })
        return s
      },
      //是否启用库位功能：拥有库位权限，且ticket里不包含"配送"
      binallocation() {
        return this.binallocationRight && !(this.ticket && this.ticket.indexOf('配送') > -1)
      }
    },
    mounted() {
      // 一次性获取所有模块权限
      getModuleRight().then(reponse => {
        var rights = ';'+reponse.data.right +';';
        this.storescanSys = rights.indexOf(';storescan;') != -1;
        this.hasBaiBao = rights.indexOf(';whitepackage;') != -1;
        this.qrcodescan = rights.indexOf(';qrcodescan;') != -1;
        this.showboxsticker = rights.indexOf(';showboxsticker;') != -1;
        this.printbacksticker = rights.indexOf(';printbacksticker;') != -1;
        this.order200print = rights.indexOf(';order200print;') != -1;
        this.supodderrequired = rights.indexOf(';supodderrequired;') != -1;
        this.binallocationRight = rights.indexOf(';binallocation;') != -1;
        this.printoutstock = rights.indexOf(';printoutstock;') != -1;
        this.printpickup = rights.indexOf(';printpickup;') != -1;
        this.xinyoneduprint = !(rights.indexOf(';xinyoneduprint;') != -1);
        this.cangkujianhuo = rights.indexOf(';cangku_jianhuo;') != -1;
        if (this.cangkujianhuo) {
          this.loadPickEmployees();
        }
      });
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      var tenantModel = JSON.parse(localStorage.getItem("hpapi_tokenModel"))
      for(let i in tenantModel.tenantDO) {
        var ten = tenantModel.tenantDO[i]
        if (ten.unitguid == this.userInfoModel.tenantid) {
          try {
            this.imgLogURLSet = JSON.parse(ten.appguidlist)[0];
          } catch (e) {
          }
          break;
        }
      }
      this.showDisplayPrice();
      this.daiGuansend = this.userInfoModel.myright.indexOf('代管仓库发货') != -1;
      getParameterDetail({paraname: "快递公司"}).then(response => {
        // this.parameterData = JSON.parse(response.data.obj.paracontent);
        if (!response.data.obj) return;
        for (let i = 0; i < JSON.parse(response.data.obj.paracontent).length; i++) {
          var obj = {
            name: '', value: ''
          }
          obj.name = JSON.parse(response.data.obj.paracontent)[i].name
          obj.value = JSON.parse(response.data.obj.paracontent)[i].name
          this.parameterData.push(obj)
        }
      })
      getParameterDetail({paraname: "退货原因"}).then(response => {
        if (!response.data.obj) return;
        this.tuihuoyy = JSON.parse(response.data.obj.paracontent);
      })
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
        if (this.jxcstoreData.length > 0)
          this.form.cangkucode = this.jxcstoreData[0].cangkucode
      })
    },
    components: {
      CstagreementEditSeedDetail,
      UpdateAddress,
      printlogList,
      StoreEdit,
      HandlelogList,
      Printtitle,
      BuyfromList,
      ScanCodeBatch,
      ScanCodeSupplyer,
      editPackage,
      UpdateExpressFee,
      Boxsticker,
      LensLabelPrint,
      PickupPrint,
      SplitOrderPrint,
      JxcgooddetailSel
    },
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementEdit.vue